import { CurrencyPipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { printReportLabel, WarrantyReportCSV } from 'app/constants/csv/constants';
import { currency } from 'app/constants/currency.constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { itemTypeLabel } from 'app/constants/itemType.constants';
import { locationReportColumnsCVS, supplierDrillDownCSV } from 'app/constants/supplierDetail';
import { CalculationService, DataService, DateService, ExportService, FormatService, HelperService, HTTPService } from 'app/services';
import { find, findIndex } from 'lodash';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-export-report-dialog',
  templateUrl: './export-report-dialog.component.html',
  styleUrls: ['./export-report-dialog.component.scss'],
})
export class ExportReportDialogComponent implements OnInit, OnDestroy {
  labels = itemTypeLabel;
  data: any = {};
  pageSize = 10;
  allReportColumns: any = {
    sales: [
      { name: 'Invoice date', value: 'invoiceDate', isChecked: true },
      { name: 'Service advisor', value: 'createdBy', isChecked: true },
      { name: 'Order', value: 'title', isChecked: true },
      { name: 'Invoice #', value: 'invCode', isChecked: true },
      { name: 'Type', value: 'customerType', isChecked: true },
      { name: 'Customers', value: 'customer', isChecked: true },
      { name: 'Company', value: 'companyName', isChecked: true },
      { name: 'Vehicle', value: 'vehicle', isChecked: true },
      { name: 'Payment status', value: 'payment', isChecked: true },
      { name: 'Sales Tax', value: 'taxAmt', isChecked: true },
      { name: 'Order amount', value: 'total', isChecked: true },
    ],
  };
  allColumns: any = {
    // item sold drilldown enhancement report
    itemSoldDrilldown: [
      { name: 'Item name', value: 'itemName', isChecked: true },
      { name: 'Item type', value: 'itemType', isChecked: true },
      { name: 'Item number', value: 'itemNumber', isChecked: true },
      { name: 'RO #', value: 'roNumber', isChecked: true },
      { name: 'Invoice #', value: 'invCode', isChecked: true },
      { name: 'Invoice date', value: 'invoiceDate', isChecked: true },
      { name: 'Customer name', value: 'customer.displayName', isChecked: true },
      { name: 'Vehicle', value: 'vehicle.name', isChecked: true },
      { name: 'Customer email', value: 'customer.email', isChecked: false },
      { name: 'Customer phone', value: 'customer.phone', isChecked: false },
      { name: 'Supplier', value: 'supplier', isChecked: true },
      { name: 'Service Advisor', value: 'serviceWriter', isChecked: true },
      { name: 'Technician', value: 'technicianString', isChecked: true },
      { name: 'Payment status', value: 'paymentStatus', isChecked: true },
      { name: 'Quantity', value: 'quantity', total: 0, isChecked: true },
      { name: 'Total Sales', value: 'subTotal', total: 0, isChecked: true },
      { name: 'Total Cost', value: 'subTotalCost', isChecked: true },
      { name: 'Profitability ', value: 'updatedprofitability', isChecked: true },
      // { name: 'Quantity sold', value: 'salesVolume', total: 0, isChecked: true },
      { name: 'Markup', value: 'markup', total: 0, isChecked: false },
      { name: 'Sales Tax', value: 'tax', total: 0, isChecked: false },
      { name: 'Discount', value: 'discount', total: 0, isChecked: false },
      { name: 'Avg price/qty', value: 'price', total: 0, isChecked: false },
      { name: 'Avg cost/qty', value: 'cost', total: 0, isChecked: false },
      { name: 'Average Profitability', value: 'profitability', total: 0, isChecked: false },
    ],
    royaltyFeeList: [
      { value: 'groupName', name: 'Group & Code Names', isChecked: true },
      { value: 'groupCode', name: 'Code', isChecked: true },
      { value: 'partSales', name: 'Part Sales', isChecked: true },
      { value: 'laborSales', name: 'Labor Sales', isChecked: true },
      { value: 'totalSales', name: 'Total Sales', isChecked: true },
      { value: 'noOfJobs', name: ' No. of Jobs', isChecked: true },
      { value: 'noOfOperations', name: 'No. of Operations', isChecked: true },
      { value: 'salesMix', name: 'Sales Mix', isChecked: true },
      // { value: 'totalRoyaltyFee', name: 'Total Royalty Fee', isChecked: true },
    ],
    itemMovmentsColumns: [
      { value: 'transactionDate', name: 'Transaction date', isShowSortIcon: false, className: 'transaction-date', isChecked: true },
      { value: 'transactionType', name: 'Transaction type', isShowSortIcon: false, className: 'transaction-type', isChecked: true },
      { value: 'itemType', name: 'Item type', isShowSortIcon: false, className: 'item-type', isChecked: true },
      { value: 'activity', name: 'Activity', isShowSortIcon: false, className: 'item-type', isChecked: true },
      { value: 'supplier', name: 'Supplier name', isShowSortIcon: false, className: 'supplier-name', isChecked: true },
      { value: 'supplierInvoiceNumber', name: 'Supplier invoice#', isShowSortIcon: false, className: 'supplier-name', isChecked: true },
      { value: 'creditNumber', name: 'Credit#', isShowSortIcon: false, className: 'invoice-number', isChecked: true },
      { value: 'code', name: 'RO#', isShowSortIcon: false, className: 'invoice-number', isChecked: true },

      { value: 'poNumber', name: 'PO#', isShowSortIcon: false, className: 'poNumber', isChecked: true },
      { value: 'source', name: 'Source', isShowSortIcon: false, className: 'source', isChecked: true },
      { value: 'stocked', name: 'Stocked', isShowSortIcon: false, className: 'source', isChecked: true },

      { value: 'deliveryDate', name: 'Delivery date', isShowSortIcon: false, className: 'delivery-date', isChecked: true },
      { value: 'title', name: 'Item name', className: 'item-name', isChecked: true },
      { value: 'cost', name: 'Cost / qty', className: 'cost', isChecked: true },
      { value: 'quantity', name: 'Qty', isShowSortIcon: false, className: 'quantity', isChecked: true },
      { value: 'itemValue', name: 'Total cost', isShowSortIcon: false, className: 'total-cost', isChecked: true },
      { value: 'tax', name: 'Tax', isShowSortIcon: false, className: 'tax', isChecked: true },
      { value: 'totalAmount', name: 'Total amount', isShowSortIcon: false, className: 'total-amount', isChecked: true },
      { value: 'inventoryAddition', name: 'Inventory addition', isShowSortIcon: false, className: 'inventory-addition', isChecked: true },
      { value: 'inventoryDeduction', name: 'Inventory deduction', isShowSortIcon: false, className: 'inventory-deduction', isChecked: true },
      { value: 'inventoryBalance', name: 'Inventory balance', isShowSortIcon: false, className: 'inventory-balance', isChecked: true },
      // { value: 'apAddition', name: 'AP addition', isShowSortIcon: false, className: 'ap-addition', isChecked: true },
      // { value: 'apDeduction', name: 'AP deduction', isShowSortIcon: false, className: 'ap-deduction', isChecked: true },
      { name: 'Exported to accounting', value: 'isExportedToReturn', isChecked: true },
      { value: 'balance', name: 'AP balance', isShowSortIcon: false, className: 'ap-balance', isChecked: true },
    ],
    apSupplier: [
      { value: 'supplier', name: 'Supplier', isChecked: true },
      { value: 'type', name: 'Type', isChecked: true },
      { value: 'paidPos', name: 'Paid POs', isChecked: true },
      { value: 'unpaidPos', name: 'Unpaid POs', isChecked: true },
      { value: 'notDue', name: 'Not due', isChecked: true },
      {
        value: 'firstMonth',
        name: '0-30 days overdue',
        isChecked: true,
      },
      {
        value: 'secondMonth',
        name: '31-60 days overdue',
        isChecked: true,
      },
      { value: 'moreThanTwoMonths', name: '61+ days overdue', isChecked: true },
      { value: 'total', name: 'Total', isChecked: true },
    ],
    apSupplierDetail: [
      { name: 'PO#', value: 'code', isChecked: true },
      { name: 'Activity Date', value: 'activityDate', isChecked: true },
      { name: 'Activity Type', value: 'activityType', isChecked: true },
      { name: 'Amount', value: 'amount', isChecked: true },
      { name: 'Running Balance', value: 'runningBalance', isChecked: true },
    ],
    sales: [
      { name: 'RO #', value: 'RO#', isChecked: true },
      { name: 'Invoiced date', value: 'Invoice date', isChecked: true },
      { name: 'Service advisor', value: 'Service advisor', isChecked: true },
      { name: 'Order', value: 'Order', isChecked: true },
      { name: 'Invoice #', value: 'Invoice #', isChecked: true },
      { name: 'Customer', value: 'Customer', isChecked: true },
      { name: 'Company', value: 'Company', isChecked: true },
      { name: 'Vehicle', value: 'Vehicle', isChecked: true },
      { name: 'Order amount', value: 'Order amount', isChecked: true },
      { name: 'Labor amount', value: 'Labor amount', isChecked: true },
      { name: 'Parts amount', value: 'Parts amount', isChecked: true },
      { name: 'Tire amount', value: 'Tire amount', isChecked: true },
      {
        name: 'Tire storage amount',
        value: 'Tire storage amount',
        isChecked: true,
      },
      {
        name: 'Service level fees',
        value: 'Service level fees',
        isChecked: true,
      },
      {
        name: 'RO level fees',
        value: 'RO level fees',
        isChecked: true,
      },
      { name: 'Other amount', value: 'Other amount', isChecked: true },
      { name: 'Sales Tax', value: 'Sales Tax', isChecked: true },
      { name: 'Total discount', value: 'Total discount', isChecked: true },
      { name: 'Customer type', value: 'Customer type', isChecked: true },
      { name: 'Amount remaining', value: 'Amount remaining', isChecked: true },
      { name: 'Payment status', value: 'Payment status', isChecked: true },
      { name: 'Payment amount', value: 'Payment amount', isChecked: true },
    ],
    googleReviews: [
      { name: 'Time & Date', value: 'Time & Date', isChecked: true },
      { name: 'Customer name', value: 'Customer name', isChecked: true },
      { name: 'Rating', value: 'Rating', isChecked: true },
      { name: 'Review', value: 'Review', isChecked: true },
      { name: 'Response', value: 'Response', isChecked: true },
      { name: 'Response time', value: 'Response time', isChecked: true },
    ],
    internalSurveys: [
      { name: 'Time & Date', value: 'Time & Date', isChecked: true },
      { name: 'Customer name', value: 'Customer name', isChecked: true },
      { name: 'Order name', value: 'Order name', isChecked: true },
      { name: 'Review', value: 'Review', isChecked: true },
      { name: 'Technician', value: 'Technician', isChecked: true },
      { name: 'Rating', value: 'Rating', isChecked: true },
    ],
    inventoryActivity: [
      { name: 'Time', value: 'createdAt', isChecked: true },
      { name: 'Item', value: 'itemName', isChecked: true },
      { name: 'Action', value: 'action', isChecked: true },
      { name: 'Primary', value: 'isPrimary', isChecked: true },
      { name: 'Purchase order', value: 'pOCode', isChecked: true },
      { name: 'Repair order', value: 'rOTitle', isChecked: true },
      { name: 'User', value: 'userFullName', isChecked: true },
      { name: 'Location', value: 'locationName', isChecked: true },
      { name: 'Average Cost', value: 'averageCost', isChecked: true },
      { name: 'Qty ordered', value: 'countOrdered', isChecked: true },
      { name: 'Qty on hand', value: 'countInHand', isChecked: true },
      { name: 'Qty available', value: 'countAvailable', isChecked: true },
      { name: 'Qty on estimates', value: 'countOnEstimate', isChecked: true },
    ],
    inventoryLevel: [
      { name: 'Location', value: 'location', isChecked: true },
      { name: 'Name', value: 'itemName', isChecked: true },
      { name: 'Type', value: 'itemType', isChecked: false },
      { name: 'Description', value: 'description', isChecked: false },
      { name: 'Average cost', value: 'averageCost', isChecked: false },
      { name: 'Qty ordered', value: 'countOrdered', isChecked: false },
      { name: 'Qty on hand', value: 'countInHand', isChecked: true },
      { name: 'Qty available', value: 'countAvailable', isChecked: false },
      { name: 'Qty on estimate', value: 'countOnEstimate', isChecked: false },
      { name: 'Stock on hand value', value: 'stockOnHand', isChecked: true },
      { name: 'Stock on estimates value', value: 'stockOnEstimate', isChecked: true },
      { name: 'Stock available value', value: 'stockValue', isChecked: true },
    ],
    payments: [
      { name: 'Time & Date', value: 'Time & Date', isChecked: true },
      { name: 'Order #', value: 'Order No.', isChecked: true },
      { name: 'Order name', value: 'Order name', isChecked: true },
      { name: 'Customer', value: 'Customer', isChecked: true },
      { name: 'Company', value: 'Company', isChecked: true },
      { name: 'Payment type', value: 'Payment type', isChecked: true },
      { name: 'QBO status', value: 'QBO status', isChecked: true },
      { name: 'Payment amount', value: 'Payment amount', isChecked: true },
      { name: 'Order amount', value: 'Order amount', isChecked: true },
      { name: 'Remaining amount', value: 'Remaining amount', isChecked: true },
      { name: 'Note', value: 'Note', isChecked: true },
    ],
    cannedService: [
      { name: 'Services invoiced', value: 'Canned service', isChecked: true },
      { name: 'Category', value: 'Category', isChecked: true },
      { name: '# Sold', value: '# Sold', isChecked: true },
      {
        name: 'Total hours worked',
        value: 'Total hours worked',
        isChecked: true,
      },
      {
        name: 'Total hours billed',
        value: 'Total hours billed',
        isChecked: true,
      },
      { name: 'Parts value (margin)', value: 'Parts margin', isChecked: true },
      { name: 'Labor value (margin)', value: 'Labor margin', isChecked: true },
      { name: 'Tire value (margin)', value: 'Tire margin', isChecked: true },
      { name: 'Tire storage value (margin)', value: 'Tire storage margin', isChecked: true },
      { name: 'Other value (margin)', value: 'Other margin', isChecked: true },
      { name: 'Fee value (margin)', value: 'Fee margin', isChecked: true },
      { name: 'Avg price', value: 'Avg price', isChecked: true },

      { name: 'Total cost', value: 'Total cost', isChecked: true },
      { name: 'Total price', value: 'Total price', isChecked: true },
      { name: 'Service discount', value: 'Service discount', isChecked: true },
      { name: 'Total profit', value: 'Total profit', isChecked: true },
      { name: 'Gross margin', value: 'Gross margin', isChecked: true },
    ],
    cannedServiceDetails: [
      { name: 'Invoice date', value: 'Invoice date', isChecked: true },
      { name: 'Invoice #', value: 'Invoice #', isChecked: true },
      { name: 'RO #', value: 'RO #', isChecked: true },

      { name: 'Parts value (margin)', value: 'Parts margin', isChecked: true },
      { name: 'Labor value (margin)', value: 'Labor margin', isChecked: true },
      { name: 'Tire value (margin)', value: 'Tire margin', isChecked: true },
      { name: 'Tire storage value (margin)', value: 'Tire storage margin', isChecked: true },
      { name: 'Fee value (margin)', value: 'Fee margin', isChecked: true },
      { name: 'Other value (margin)', value: 'Other margin', isChecked: true },
      // { name: 'Avg price', value: 'Avg price', isChecked: true },
      { name: 'Total cost', value: 'totalCost', isChecked: true },
      { name: 'Total price', value: 'totalPrice', isChecked: true },
      { name: 'Service discount', value: 'serviceLevelDiscount', isChecked: true },
      { name: 'Total profit', value: 'totalProfit', isChecked: true },
      { name: 'Gross margin', value: 'grossMargin', isChecked: true },
    ],
    customer: [
      { name: 'Customer', value: 'Customer', isChecked: true },
      { name: 'Company', value: 'Company', isChecked: true },
      { name: 'Email', value: 'Email', isChecked: true },
      { name: 'Mobile', value: 'Mobile', isChecked: true },
      { name: 'Created date', value: 'Created date', isChecked: true },
      { name: 'No. of vehicles', value: 'No. of vehicles', isChecked: true },
      { name: 'Total sales', value: 'Total sales', isChecked: true },
      { name: 'Total Payments', value: 'Total Payments', isChecked: true },
      {
        name: 'Outstanding payments',
        value: 'Outstanding payments',
        isChecked: true,
      },
    ],
    order: [
      { name: 'Order', value: 'Order', isChecked: true },
      { name: 'Invoice #', value: 'Invoice #', isChecked: true },
      { name: 'Customer', value: 'Customer', isChecked: true },
      { name: 'Vehicle', value: 'Vehicle', isChecked: true },
      { name: 'VIN', value: 'VIN', isChecked: true },
      { name: 'Date created', value: 'Date created', isChecked: true },
      { name: 'Date invoiced', value: 'Date invoiced', isChecked: true },
      {
        name: 'Last payment posted',
        value: 'Last payment posted',
        isChecked: true,
      },
      { name: 'Company', value: 'Company', isChecked: true },
      { name: 'Payment status', value: 'Payment status', isChecked: true },
      { name: 'Order status', value: 'Order status', isChecked: true },
      { name: 'Workflow status', value: 'Workflow status', isChecked: true },
      { name: 'Labor price', value: 'Labor price', isChecked: true },
      { name: 'Parts price', value: 'Parts price', isChecked: true },
      { name: 'Tire price', value: 'Tire price', isChecked: true },
      // { name: 'Tire storage price', value: 'Tire storage price', isChecked: true },
      { name: 'Other', value: 'Other', isChecked: true },
      { name: 'Shop supplies', value: 'Shop supplies', isChecked: true },
      { name: 'RO Fee', value: 'RO Fee', isChecked: true },
      {
        name: 'Total service fee',
        value: 'Fee',
        isChecked: true,
      },
      { name: 'Sales Tax', value: 'Tax', isChecked: true },
      { name: 'Item discount', value: 'Item discount', isChecked: true },
      { name: 'Service discount', value: 'Service discount', isChecked: true },
      { name: 'Order discount', value: 'Order discount', isChecked: true },
      { name: 'Total paid', value: 'Total paid', isChecked: true },
      {
        name: 'Total order amount',
        value: 'Total order amount',
        isChecked: true,
      },
    ],
    outstandingInvoice: [
      { name: 'Invoiced Date', value: 'Invoiced Date', isChecked: true },
      { name: 'Customer', value: 'Customer', isChecked: true },
      { name: 'Company', value: 'Company', isChecked: true },
      { name: 'Vehicle', value: 'Vehicle', isChecked: true },
      { name: 'Workflow status', value: 'Workflow status', isChecked: true },
      { name: 'Archive status', value: 'Archive status', isChecked: true },
      { name: 'Order', value: 'Order', isChecked: true },
      { name: 'Invoice #', value: 'Invoice #', isChecked: true },
      { name: 'Order amount', value: 'Order amount', isChecked: true },
      { name: 'Payment amount', value: 'Payment amount', isChecked: true },
      { name: 'Remaining amount', value: 'Remaining amount', isChecked: true },
    ],
    orderarbycustomer: [
      { name: 'Customer', value: 'customer', isChecked: true },
      { name: 'Type', value: 'type', isChecked: true },
      { name: '0-30', value: 'firstMonth', isChecked: true },
      { name: '30-60', value: 'secondMonth', isChecked: true },
      { name: '60-90', value: 'thirdMonth', isChecked: true },
      { name: '90+', value: 'MoreThanThreeMonths', isChecked: true },
      { name: 'Total', value: 'total', isChecked: true },
      { name: 'Phone Number', value: 'phone', isChecked: true },
      { name: 'Email', value: 'email', isChecked: true },
      { name: 'Unpaid Invoices', value: 'invoices', isChecked: true },
      { name: 'Unpaid Statements', value: 'unpaidStatements', isChecked: true },
      { name: 'Last Statement Sent', value: 'lastStatementSent', isChecked: true },
    ],
    orderArMovement: [
      { value: 'transactionDate', name: 'Transaction Date', isChecked: true },
      { value: 'finalizeDate', name: 'Finalize Date', isChecked: true },
      { value: 'paymentDate', name: 'Payment Date', isChecked: true },
      { value: 'transactionType', name: 'Transaction Type', isChecked: true },
      { value: 'customer', name: 'Customer', isChecked: true },
      { value: 'invoiceNumber', name: 'Invoice #', isChecked: true },
      { value: 'vehicle', name: 'Vehicle', isChecked: true },
      {
        value: 'paymentType',
        name: 'Payment Type',
        isChecked: true,
      },
      { value: 'paymentMethod', name: 'Payment Method', isChecked: true },
      { value: 'preTaxAmount', name: 'Pre-tax Amount', isChecked: true },
      { value: 'salesTaxAmount', name: 'Sales tax Amount', isChecked: true },
      { value: 'totalAmount', name: 'Total Amount', isChecked: true },
      { value: 'sendToAR', name: 'Sent to AR (Debit)', isChecked: true },
      { value: 'paidAgainstAR', name: 'Paid against AR (Credit)', isChecked: true },
      { value: 'balance', name: 'Balance', isChecked: true },
    ],
    dailyPaymentReport: [
      { name: 'Activity type', value: 'activityType', isChecked: true },
      { name: 'Date', value: 'paymentDate', isChecked: true },
      { name: 'RO #', value: 'Invoice', isChecked: true },
      { name: 'Invoice #', value: 'invoiceCode', isChecked: true },
      { name: 'Statement', value: 'statementName', isChecked: true },
      { name: 'Customer Type', value: 'customerType', isChecked: true },
      { name: 'Customer', value: 'customer', isChecked: true },
      { name: 'Payment Method', value: 'paymentMethod', isChecked: true },
      { name: 'Outstanding Amount', value: 'outstanding-amount', isChecked: true },
      { name: 'Paid', value: 'amount', isChecked: true },
      { name: 'Total', value: 'total', isChecked: true },
    ],
    allPayments: [
      { name: 'Payment date', value: 'Payment date', isChecked: true },
      { name: 'Order', value: 'Order', isChecked: true },
      { name: 'Invoice #', value: 'Invoice #', isChecked: true },
      { name: 'Customer', value: 'Customer', isChecked: true },
      { name: 'Company', value: 'Company', isChecked: true },
      { name: 'Payment type', value: 'Payment type', isChecked: true },
      { name: 'Payment  method', value: 'Payment method', isChecked: true },
      { name: 'Payment amount', value: 'Payment amount', isChecked: true },
      { name: 'Order amount', value: 'Order amount', isChecked: true },
      { name: 'Remaining amount', value: 'Remaining amount', isChecked: true },
      { name: 'Note', value: 'Note', isChecked: true },
    ],
    allPaymentsStats: [
      { name: 'Payment method', value: 'pMethod' },
      { name: 'Amount', value: 'amount' },
      { name: 'Count', value: 'count' },
    ],
    technicianActivity: [
      { name: 'Time & date', value: 'Time & date', isChecked: true },
      { name: 'Technician', value: 'Technician', isChecked: true },
      { name: 'Order #', value: 'Order No', isChecked: true },
      { name: 'Order name', value: 'Order name', isChecked: true },
      { name: 'Activity type', value: 'Activity type', isChecked: true },
      { name: 'Activity name', value: 'Activity name', isChecked: true },
      { name: 'Activity status', value: 'Activity status', isChecked: true },
      { name: 'Customer', value: 'Customer', isChecked: true },
      { name: 'Vehicle', value: 'Vehicle', isChecked: true },
    ],
    technicianSummary: [
      { name: 'Technician', value: 'name', isChecked: true },
      { name: 'Single Tech Services', value: 'singleTechServices', isChecked: true },
      { name: 'Multi Tech Services', value: 'multiTechServices', isChecked: true },

      { name: 'Billable total hours', value: 'billableTotalHours', isChecked: true },
      { name: 'Billable total price', value: 'billableTotalCost', isChecked: true },
      { name: 'Billable approved hours', value: 'billableApprovedHours', isChecked: true },
      { name: 'Billable approved Price', value: 'billableApprovedCost', isChecked: true },

      { name: 'Estimated total hours', value: 'estimatedTotalHours', isChecked: true },
      { name: 'Estimated total cost', value: 'estimatedTotalCost', isChecked: true },
      { name: 'Estimated approved hours', value: 'estimatedApprovedHours', isChecked: true },
      { name: 'Estimated approved cost', value: 'estimatedApprovedCost', isChecked: true },

      { name: 'Actual total hours', value: 'actualTotalHours', isChecked: true },
      { name: 'Actual total cost', value: 'actualTotalCost', isChecked: true },
      { name: 'Actual approved hours', value: 'actualApprovedHours', isChecked: true },
      { name: 'Actual approved cost', value: 'actualApprovedCost', isChecked: true },
      { name: 'Tech Efficiency', value: 'efficiency', isChecked: true },
      { name: 'Tech Productivity', value: 'productivity', isChecked: true },
    ],
    techDetail: [
      { name: 'Technician', value: 'Technician', isChecked: true },
      { name: 'RO #', value: 'RO', isChecked: true },
      { name: 'Customer', value: 'Customer', isChecked: true },
      { name: 'Invoice Date', value: 'Invoice Date', isChecked: true },
      { name: 'Service', value: 'Service', isChecked: true },
      { name: 'Start', value: 'Start', isChecked: true },
      { name: 'End', value: 'End', isChecked: true },
      { name: 'Status', value: 'Status', isChecked: true },
      // { name: 'Tech Credit %', value: 'Tech Credit %', isChecked: true },
      { name: 'Estimated hrs', value: 'plannedHours', isChecked: true },
      { name: 'Billable hrs', value: 'billedHours', isChecked: true },
      { name: 'Tech time worked', value: 'hoursWorked', isChecked: true },
      { name: 'Tech worked cost', value: 'actualTotalCost', isChecked: true },

      // { name: 'Tech Cost', value: 'Tech Cost', isChecked: true },
      // { name: 'Billed Hours', value: 'Billed Hours', isChecked: true },
      // { name: 'Efficiency', value: 'Efficiency', isChecked: true },
    ],
    techAllSummary: [
      { name: 'Technician', value: 'Technician', isChecked: true },

      { name: 'Billable total hours', value: 'billableTotalHours', isChecked: true },
      { name: 'Billable total price', value: 'billableTotalCost', isChecked: true },
      { name: 'Billable approved hours', value: 'billableApprovedHours', isChecked: true },
      { name: 'Billable approved price', value: 'billableApprovedCost', isChecked: true },

      { name: 'Estimated total hours', value: 'estimatedTotalHours', isChecked: true },
      { name: 'Estimated total cost', value: 'estimatedTotalCost', isChecked: true },
      { name: 'Estimated approved hours', value: 'estimatedApprovedHours', isChecked: true },
      { name: 'Estimated approved cost', value: 'estimatedApprovedCost', isChecked: true },
    ],
    techAllSummaryDetail: [
      { name: 'Invoice Date', value: 'invoiceDate', isChecked: true },
      { name: 'Technician', value: 'technician', isChecked: true },
      { name: 'RO #', value: 'RO', isChecked: true },
      { name: 'Customer', value: 'customer', isChecked: true },
      { name: 'Service', value: 'service', isChecked: true },
      { name: 'Status', value: 'status', isChecked: true },
      { name: 'Role', value: 'role', isChecked: true },
      // { name: 'Hours Worked', value: 'workedHours', isChecked: true },
      // { name: 'Tech Cost', value: 'techCost', isChecked: true },
      { name: 'Billed Hours', value: 'billableHours', isChecked: true },
      { name: 'Hours estimated', value: 'estimatedHours', isChecked: true },
      // { name: 'Billed amount', value: 'billedAmount', isChecked: true },
      // { name: 'Efficiency', value: 'efficiency', isChecked: true },
    ],
    profitability: [
      { name: 'RO #', value: 'RO#', isChecked: true },
      { name: 'Order', value: 'Order', isChecked: true },
      { name: 'Invoice #', value: 'Invoice #', isChecked: true },
      { name: 'Payment status', value: 'Payment status', isChecked: true },
      { name: 'Service advisor', value: 'Service advisor', isChecked: true },
      { name: 'Customer', value: 'Customer', isChecked: true },
      { name: 'Company', value: 'Company', isChecked: true },
      { name: 'RO Price', value: 'RO Price', isChecked: true },
      { name: 'RO Cost', value: 'RO Cost', isChecked: true },
      { name: 'RO Margin	', value: 'RO Margin', isChecked: true },
      { name: 'Part Price', value: 'Part Price', isChecked: true },
      { name: 'Part Cost', value: 'Part Cost', isChecked: true },
      { name: 'Part Margin', value: 'Part Margin', isChecked: true },
      { name: 'Labor Price', value: 'Labor Price', isChecked: true },
      { name: 'Labor Cost', value: 'Labor Cost', isChecked: true },
      { name: 'Labor Margin', value: 'Labor Margin', isChecked: true },
      { name: 'Tire Price', value: 'Tire Price', isChecked: true },
      { name: 'Tire Cost', value: 'Tire Cost', isChecked: true },
      { name: 'Tire Margin', value: 'Tire Margin', isChecked: true },
      { name: 'Other Price', value: 'Other Price', isChecked: true },
      { name: 'Other Cost', value: 'Other Cost', isChecked: true },
      { name: 'Other Margin', value: 'Other Margin', isChecked: true },
      { name: 'Fees Price', value: 'Fees Price', isChecked: true },
      { name: 'Fees Cost', value: 'Fees Cost', isChecked: true },
      {
        name: 'Fees Margin',
        value: 'Fees Margin',
        isChecked: true,
      },
      { name: 'Order Discount', value: 'Order Discount', isChecked: true },
      {
        name: 'Parts line discount',
        value: 'Parts line discount',
        isChecked: true,
      },
      {
        name: 'Labor line discount',
        value: 'Labor line discount',
        isChecked: true,
      },
      {
        name: 'Tire line discount',
        value: 'Tire line discount',
        isChecked: true,
      },
      {
        name: 'Other line discount',
        value: 'Other line discount',
        isChecked: true,
      },
      { name: 'RO line discount', value: 'RO line discount', isChecked: true },
      { name: 'Shop Supplies', value: 'Shop Supplies', isChecked: true },
    ],
    attendanceLogDetail: [
      { name: 'Start Time', value: 'Start Time', isChecked: true },
      { name: 'End Time', value: 'End Time', isChecked: true },
      { name: 'Duration', value: 'Duration', isChecked: true },
      { name: 'Technician', value: 'Technician', isChecked: true },
      { name: 'RO #', value: 'RO', isChecked: true },
      { name: 'Service', value: 'Service', isChecked: true },
      { name: 'Status', value: 'Status', isChecked: true },
    ],
    taxRateDrilldown: [
      { name: 'Rate', value: 'taxRateName', isChecked: true },
      { name: 'Code', value: 'taxCodeId', isChecked: true },
      { name: 'Order #', value: 'code', isChecked: true },
      { name: 'Invoice #', value: 'invCode', isChecked: true },
      { name: 'Invoice date', value: 'invoiceDate', isChecked: true },
      { name: 'Order status', value: 'orderStatus', isChecked: true },
      { name: 'Payment status', value: 'paymentStatus', isChecked: true },
      { name: 'Code %', value: 'taxPercentage', isChecked: true },
      { name: 'Total tax', value: 'taxAmount', isChecked: true },
      { name: 'Rate%', value: 'taxRatePercentage', isChecked: true },
      { name: 'Tax rate charged', value: 'taxRateAmount', isChecked: true },
    ],
    taxReport: [
      { name: 'Tax Code', value: 'taxCodeId', isChecked: true },
      { name: 'Tax code %', value: 'percentage', isChecked: true },
      { name: 'Tax rate', value: 'id', isChecked: true },
      { name: 'Gross Amount', value: 'grossAmount', isChecked: true },
      { name: 'Non-taxable amount', value: 'nonTaxableAmount', isChecked: true },
      { name: 'Taxable Amount', value: 'taxableAmount', isChecked: true },
      { name: 'Tax amount', value: 'taxedAmount', isChecked: true },
    ],
    supplierReport: [
      { name: 'Supplier name', value: 'supplierName', isChecked: true },
      { name: 'Supplier Type', value: 'suppliertype', isChecked: true },
      { name: 'Number of items purchased', value: 'totalNumberOfItemsPurchased', isChecked: true },
      { name: 'Total Purchase value', value: 'totalPurchaseValue', isChecked: true },
      { name: 'Volume purchased', value: 'totalVolumePurchased', isChecked: true },
    ],
    updatedSupplierReport: [
      { name: 'Supplier name', value: 'supplierName', isChecked: true },
      { name: 'Supplier Type', value: 'suppliertype', isChecked: true },
      { name: 'Item purchase value', value: 'totalNumberOfItemsPurchased', isChecked: true },
      { name: 'Item return value', value: 'totalNumberOfItemsReturned', isChecked: true },
      { name: 'Core return value', value: 'totalNumberOfCoreReturned', isChecked: true },
      { name: 'Net purchase value', value: 'totalNetPurchaseValue', isChecked: true },
    ],
    supplierDetails: [
      { name: 'Supplier name', value: 'supplierName', isChecked: true },
      { name: 'Supplier type', value: 'suppliertype', isChecked: true },
      { name: 'Activity date', value: 'activityDate', isChecked: true },
      { name: 'Activity type', value: 'activityType', isChecked: true },
      { name: 'Item type', value: 'itemType', isChecked: true },
      { name: 'Item name', value: 'itemName', isChecked: true },
      { name: 'Order method', value: 'orderingMethod', isChecked: true },
      { name: 'PO #', value: 'pos', isChecked: true },
      { name: 'Payment term', value: 'paymentTerm', isChecked: true },
      { name: 'RO #', value: 'ros', isChecked: true },
      { name: 'Cost', value: 'cost', isChecked: true },
      { name: 'Quantity', value: 'quantity', isChecked: true },
      { name: 'Tax', value: 'taxedAmount', isChecked: true },
      { name: 'Subtotal', value: 'subTotal', isChecked: true },
      { name: 'Order status', value: 'orderingStatus', isChecked: true },
    ],
    breakdownTaxReport: [
      { name: 'Item type', value: 'typeLabel', isChecked: true },
      { name: 'Taxable amount', value: 'taxableAmt', isChecked: true },
      { name: 'Non taxable amount', value: 'nonTaxableAmt', isChecked: true },
      { name: 'Tax', value: 'tax', isChecked: true },
      { name: 'Gross Amount', value: 'total', isChecked: true },
    ],
    breakdownTaxDetailsReport: [
      { name: 'Item type', value: 'type', isChecked: true },
      { name: 'Name', value: 'name', isChecked: true },
      { name: 'RO #', value: 'roCode', isChecked: true },
      { name: 'Customer', value: 'customer', isChecked: true },
      { name: 'Taxable', value: 'taxAble', isChecked: true },
      { name: 'Tax code', value: 'taxCode', isChecked: true },
      { name: 'Taxable amount', value: 'taxAbleAmt', isChecked: true },
      { name: 'Non-taxable amount', value: 'nonTaxAbleAmt', isChecked: true },
      { name: 'Tax amount', value: 'taxAmt', isChecked: true },
    ],
    itemDetailsReport: [
      { name: 'RO #', value: 'roNumber', isChecked: true },
      { name: 'Invoice #', value: 'invCode', isChecked: true },
      { name: 'Invoice date', value: 'invoiceDate', isChecked: true },
      { name: 'Customer name', value: 'customerName', isChecked: true },
      { name: 'Vehicle', value: 'vehicleName', isChecked: true },
      { name: 'Customer email', value: 'customerEmail', isChecked: true },
      { name: 'Customer phone', value: 'customerPhone', isChecked: true },
      { name: 'Service Advisor', value: 'serviceWriter', isChecked: true },
      { name: 'Supplier', value: 'supplier', isChecked: true },
      { name: 'Cost/Qty', value: 'cost', isChecked: true },
      { name: 'Markup', value: 'markup', isChecked: true },
      { name: 'Price/Qty', value: 'price', isChecked: true },
      { name: 'Quantity', value: 'quantity', isChecked: true },
      // { name: 'Dot Number', value: 'dotNumber', isChecked: true },
      { name: 'Sales Tax', value: 'tax', isChecked: true },
      { name: 'Discount', value: 'discount', isChecked: true },
      { name: 'Subtotal', value: 'subTotal', isChecked: true },
      { name: 'Average Profitability', value: 'profitability', isChecked: true },
    ],
    itemSoldReport: [
      { name: 'Item type', value: 'itemType', isChecked: true },
      { name: 'Item name', value: 'itemName', isChecked: true },
      { name: 'Item number', value: 'itemNumber', isChecked: true },
      { name: 'Item category', value: 'itemCategory', isChecked: true },
      { name: 'Inventory item', value: 'inventoryItem', isChecked: true },
      { name: 'Average price per quantity', value: 'salesValue', isChecked: true },
      { name: 'Quantity sold', value: 'salesVolume', isChecked: true },
      { name: 'Net amount', value: 'totalSalesValue', isChecked: true },
      { name: 'Average profitability per item', value: 'avgprofatibilty', isChecked: true },
      // { name: 'Service writer', value: 'serviceWriter', isChecked: true },

    ],
    itemSoldReportEnhancement: [
      { name: 'Item type', value: 'itemType', isChecked: true },
      { name: 'Item name', value: 'itemName', isChecked: true },
      { name: 'Item number', value: 'itemNumber', isChecked: true },
      { name: 'Item category', value: 'itemCategory', isChecked: true },
      { name: 'Description', value: 'description', isChecked: false },
      // { name: 'Sales group', value: 'salesGroup', isChecked: false },
      // { name: 'Sales code', value: 'salesCode', isChecked: false },
      { name: 'Quantity sold', value: 'salesVolume', isChecked: true },
      { name: 'Total sales', value: 'totalSalesValue', isChecked: true },
      { name: 'Total cost', value: 'totalCostValue', isChecked: true },
      { name: 'Profitability', value: 'profitability', isChecked: true },
      { name: 'Avg. price per quantity', value: 'salesValue', isChecked: true },
      { name: 'Avg. cost per quantity', value: 'averageCost', isChecked: false },
      // { name: 'Inventory item', value: 'inventoryItem', isChecked: false },
      // { name: 'Service writer', value: 'serviceWriter',: 'serviceWriter',,
      // { name: 'Net amount', value: 'totalSalesValue',isChecked: true },
      { name: 'Avg. profitability per item', value: 'avgprofatibilty', isChecked: true },
    ],
    laborReport: [
      { name: 'Item Source', value: 'itemSource', isChecked: true },
      { name: 'Item Name', value: 'itemName', isChecked: true },
      { name: 'Avg Estimate Hours', value: 'avgEstimateHours', isChecked: true },
      { name: 'Avg Billable Hours', value: 'avgBillableHours', isChecked: true },
      { name: 'Avg Cost', value: 'avgCost', isChecked: true },
      { name: 'Avg Price', value: 'avgPrice', isChecked: true },
      { name: 'Quantity Sold', value: 'timeSold', isChecked: true },
      { name: 'Total Estimated Hours', value: 'totalEstimateHours', isChecked: true },
      { name: 'Total Billable Hours', value: 'totalBillableHours', isChecked: true },
      { name: 'Total Cost', value: 'totalCost', isChecked: true },
      { name: 'Total Sales', value: 'totalSales', isChecked: true },
      { name: 'Total Profit', value: 'totalProfitability', isChecked: true },
      // { name: 'Total Hours Worked', value: 'totalHoursWorked', isChecked: true },
    ],
    laborReportDrillDown: [
      { name: 'RO #', value: 'roNumber', isChecked: true },
      { name: 'Invoice Date', value: 'invoiceDate', isChecked: true },
      { name: 'Profitability', value: 'profitability', isChecked: true },
      { name: 'Discount', value: 'discount', isChecked: true },
      { name: 'Estimated Hours', value: 'estimatedHours', isChecked: true },
      { name: 'Estimated Rate', value: 'estimatedRate', isChecked: true },
      { name: 'Billable Hours', value: 'billableHours', isChecked: true },
      // { name: 'Total Hours', value: 'totalHours', isChecked: true },
      { name: 'Billable Rate', value: 'billableRate', isChecked: true },
      { name: 'Sales', value: 'sales', isChecked: true },
    ],
    feeItemDrillDown: [
      { name: 'RO #', value: 'orderCode', isChecked: true },
      { name: 'Invoice date', value: 'invoiceDate', isChecked: true },
      { name: 'Cost/unit', value: 'cost', isChecked: true },
      { name: 'Price/unit', value: 'price', isChecked: true },
      { name: 'Qty', value: 'count', isChecked: true },
      { name: 'Total Price', value: 'totalPrice', isChecked: true },
      { name: 'Total Cost', value: 'totalCost', isChecked: true },
      { name: 'Profitability', value: 'profitability', isChecked: true },
    ],
    discountDrillDown: [
      { name: 'Applied on', value: 'appliedOn', isChecked: true },
      { name: 'Discount type', value: 'discountType', isChecked: true },
      { name: 'Discount value', value: 'discountValue', isChecked: true },
      { name: 'RO #', value: 'roNumber', isChecked: true },
      { name: 'Customer name', value: 'customerName', isChecked: true },
      { name: 'Order value', value: 'orderValue', isChecked: true },
      { name: 'Discount value on RO', value: 'valueOnRO', isChecked: true },
    ],
    feeReport: [
      { name: 'Fee type', value: 'type', isChecked: true },
      { name: 'Fee name', value: 'name', isChecked: true },
      { name: 'Avg fee price', value: 'price', isChecked: true },
      { name: 'Avg fee cost', value: 'cost', isChecked: true },
      { name: 'ROs sold', value: 'timeSold', isChecked: true },
      { name: 'Qty sold', value: 'qtySold', isChecked: true },
      { name: 'Total fee price', value: 'totalPrice', isChecked: true },
      { name: 'Total fee cost', value: 'totalCost', isChecked: true },
      { name: 'Profitability', value: 'profitability', isChecked: true },
    ],
    discountSummaryReport: [
      { name: 'Discount Name', value: 'discountName', isChecked: true },
      { name: 'Applied on', value: 'appliedOn', isChecked: true },
      { name: 'Discount Type', value: 'discountType', isChecked: true },
      { name: 'Average discount per RO', value: 'averageDiscount', isChecked: true },
      { name: 'Times added to RO', value: 'addedToRO', isChecked: true },
    ],
    commissionSummaryReport: [
      { name: 'Name', value: 'name', isChecked: true },
      { name: 'Role', value: 'role', isChecked: true },
      { name: 'ROs', value: 'noOfOrders', isChecked: true },
      { name: 'Commission plan', value: 'commissionName', isChecked: true },
      { name: 'Plan details', value: 'commissionDetail', isChecked: true },
      { name: 'Commission earned', value: 'commissionEarned', isChecked: true },
    ],
    commissionDetailReport: [
      { name: 'RO #', value: 'code', isChecked: true },
      { name: 'Role', value: 'role', isChecked: true },
      { name: 'Commission Plan', value: 'commissionName', isChecked: true },
      { name: 'Plan details', value: 'commissionDetail', isChecked: true },
      { name: 'Commission earned', value: 'commissionEarned', isChecked: true },
    ],
    unusedReport: [
      { class: 'partName', value: 'partName', name: 'Item name', isChecked: true },
      { class: 'type', value: 'type', name: 'Item type', isChecked: true },
      { class: 'source', value: 'source', name: 'Source', isChecked: true },
      { class: 'roCode', value: 'roCode', name: 'RO #', isChecked: true },
      { class: 'orderDate', value: 'orderDate', name: 'Order placed', isChecked: true },
      { class: 'rOStatus', value: 'rOStatus', name: 'RO status', isChecked: true },
      { class: 'taxValue', value: 'taxValue', name: 'Tax', isChecked: true },
      { class: 'quantity', value: 'quantity', name: 'Order qty', isChecked: true },
      { class: 'serviceQty', value: 'serviceQty', name: 'Service qty', isChecked: true },
      { class: 'qtyReturned', value: 'qtyReturned', name: 'Qty returned', isChecked: true },
      { class: 'qtyAddedToInventory', value: 'qtyAddedToInventory', name: 'Qty added to inventory', isChecked: true },
      { class: 'unusedQty', value: 'unusedQty', name: 'Unused qty', isChecked: true },
      { class: 'taxValue', value: 'taxValue', name: 'Tax', isChecked: true },
      { class: 'stockValue', value: 'stockValue', name: 'Purchase value', isChecked: true },
      { class: 'stockValue', value: 'unUsedStockValue', name: 'Unused value', isChecked: true },
    ],
    warrantyReport: WarrantyReportCSV,
  };

  finalizeColumn: any = {
    value: 'finalizeDate',
    name: 'Finalize date',
    isChecked: true,
  };
  finalizeType: any = {
    value: 'finalizeType',
    name: 'Finalize type',
    isChecked: true,
  };
  itemSoldDrilldownTiresColumns = [
    { name: 'Brand', value: 'brand', isShowSortIcon: false, class: 'customerName', isChecked: false },
    { name: 'Model', value: 'model', isShowSortIcon: false, class: 'customerName', isChecked: false },
    { name: 'Raw Tire Size', value: 'size', isShowSortIcon: false, class: 'customerName', isChecked: false },
    { name: 'Tire Type', value: 'tireType', isShowSortIcon: false, class: 'customerName', isChecked: false },
    { name: 'Load Index', value: 'loadIndex', isShowSortIcon: false, class: 'costPerUnit', isChecked: false },
    { name: 'Load Index Dual', value: 'loadIndexDual', isShowSortIcon: false, class: 'costPerUnit', isChecked: false },
    { name: 'Speed Rating', value: 'speedRating', isShowSortIcon: false, class: 'costPerUnit', isChecked: false },
    { name: 'Load Range', value: 'loadRange', isShowSortIcon: false, class: 'costPerUnit', isChecked: false },
    { name: 'Sidewall Style', value: 'sideWallStyle', isShowSortIcon: false, class: 'costPerUnit', isChecked: false },
    { name: 'UTQG', value: 'utqg', isShowSortIcon: false, class: 'customerName', isChecked: false },
    // { name: 'Warranty', value: 'warranty', isShowSortIcon: false, class: 'customerName', isChecked: false },
  ];

  columns: any;
  id: any;
  isDrillDown: boolean = false;
  filter: any;
  finalData: any = [];
  fileName: string;
  processing: boolean = false;
  filterState: any = {};
  isTireStorageEnabled: boolean = false;
  baseTax: boolean = false;
  taxType: any = '';
  dataServiceSubscription: Subscription;
  isFiltersApply = true;
  paramFilters: any = {};
  printReportLabel = printReportLabel;
  paymentStatsColumns: any;
  paymentStats: any = [];
  paymentStatsFilename: string = '';
  searchQuery: string = '';
  runningBalance: number = 0;
  isSplitTechActuallBillableHrs: boolean = false;
  isSupplierReportEnabled: boolean = false;
  isRevenueRecognitionSettleEnabled: boolean = false;
  isSubletTrackingEnabled: boolean = false;
  isPassThroughTaxEnable: boolean = false;
  isSalesCodeEnabled: boolean = false;
  isNewItemCategoriesEnable: boolean = false;
  isPartWarrantiesEnabled: boolean = false;
  isTireWarrantyPolicyEnabled: boolean = false;
  itemType: any[] = [];
  serverTime: any;
  currentServerTime: any;
  shopsMap: any;
  query: any;
  isMidasEnabled: boolean = false;
  isExportedToReturn: string = '';
  efficiency: any = [];
  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    public helperService: HelperService,
    private httpService: HTTPService,
    private formatService: FormatService,
    private exportService: ExportService,
    private dataService: DataService,
    private dateService: DateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private currencyPipe: CurrencyPipe,
    public calculationService: CalculationService,
  ) { }

  setFinalizeTypeFilter(genericFilterValues: any[], event: any) {
    if (this.isRevenueRecognitionSettleEnabled) {
      this.formatService.formatRevenueRecognitionAppliedFilter(genericFilterValues, event);
    }
  }

  async ngOnInit() {
    const { id, filter, data, formatFilterState, searchQuery, drilldown = false, selectedColumns } = this.dynamicDialogConfig.data;
    this.query = { ...this.activatedRoute?.queryParams, ...this.activatedRoute?.snapshot?.queryParams };
    this.id = id;
    this.filter = filter;
    this.filter.dateType = this.dataService.dateType || '';
    this.data = data;
    this.filterState = formatFilterState;
    this.searchQuery = searchQuery;
    this.isDrillDown = drilldown;
    this.isSupplierReportEnabled = this.dataService.isSupplierReportEnabled;
    this.isRevenueRecognitionSettleEnabled = this.dataService.isRevenueRecognitionSettleEnabled && this.filter.dateType === 'finalizeDate';
    this.isSubletTrackingEnabled = this.dataService.isSubletTrackingEnabled;
    this.isPassThroughTaxEnable = this.dataService.isPassThroughTaxEnable;
    this.isSalesCodeEnabled = this.dataService.isSalesCodeEnabled;
    this.isNewItemCategoriesEnable = this.dataService.isNewItemCategoriesEnable;
    this.isPartWarrantiesEnabled = this.dataService.isPartWarrantiesEnabled;
    this.isTireWarrantyPolicyEnabled = this.dataService.isTireWarrantyPolicyEnabled;
    this.isTireStorageEnabled = this.dataService.isTireStorageEnabled;
    this.serverTime = await this.httpService.getServerTime();
    this.currentServerTime = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(this.serverTime), datetimeFormat.yyyymmddhhmm);

    this.setMultiTechColumn();
    if (this.id === 'sales') {
      if (this.filterState.isPrint) {
        this.columns = this.allReportColumns.sales;
        if (this.isRevenueRecognitionSettleEnabled) {
          if (!find(this.columns, { value: this.columns.value })) {
            this.columns.splice(findIndex(this.columns, { value: 'invoiceDate' }), 1, this.finalizeColumn);
            this.columns.splice(findIndex(this.columns, { value: 'finalizeDate' }) + 1, 0, this.finalizeType);
          }
        }
        const { isMultiLocationEnabled } = this.dataService;
        if (isMultiLocationEnabled) {
          this.columns.splice(1, 0, {
            value: 'shopId',
            name: 'Location',
            isChecked: true,
          });
        }

        if (this.isPassThroughTaxEnable) {
          this.columns.splice(findIndex(this.columns, { value: 'taxAmt' }), 0, { name: 'Passthrough Tax', value: 'passThroughTax', isChecked: true });
        }
      } else {
        this.columns = this.allColumns.sales;
        if (this.isRevenueRecognitionSettleEnabled) {
          if (!find(this.columns, { value: this.columns.value })) {
            this.columns.splice(findIndex(this.columns, { value: 'Invoice date' }), 1, this.finalizeColumn);
            this.columns.splice(findIndex(this.columns, { value: 'finalizeDate' }) + 1, 0, this.finalizeType);
          }
        }
        if (this.isPassThroughTaxEnable) {
          this.columns.splice(findIndex(this.columns, { value: 'Sales Tax' }), 0, { name: 'Passthrough Tax', value: 'Passthrough Tax', isChecked: true });
        }
        const { isMultiLocationEnabled } = this.dataService;
        if (isMultiLocationEnabled) {
          this.columns.splice(2, 0, {
            value: 'shopId',
            name: 'Location',
            isChecked: true,
          });
        }

        if (this.isSubletTrackingEnabled) {
          const index = findIndex(this.columns, { value: 'Tire amount' });

          if (index > -1 && this.columns[index + 1] && this.columns[index + 1].value !== 'Sublet amount') {
            this.columns.splice(index + 1, 0, { name: 'Sublet amount', value: 'Sublet amount', isChecked: true });
          }
        }

        if (this.isSubletTrackingEnabled) {
          const index = findIndex(this.columns, { value: 'Tire amount' });

          if (index > -1 && this.columns[index + 1] && this.columns[index + 1].value !== 'Sublet amount') {
            this.columns.splice(index + 1, 0, { name: 'Sublet amount', value: 'Sublet amount', isChecked: true });
          }
        }
      }

      this.fileName = 'sales-trend-report';
      this.downloadSalesReport(this.filter);
    } else if (this.id === 'profitability') {
      this.columns = this.allColumns.profitability;
      const { isMultiLocationEnabled } = this.dataService;
      if (isMultiLocationEnabled) {
        this.columns.splice(2, 0, {
          value: 'shopId',
          name: 'Location',
          isChecked: true,
        });
      }

      if (this.isTireStorageEnabled) {
        const index = findIndex(this.columns, { value: 'Tire Margin' });

        if (index > -1 && this.columns[index + 1] && this.columns[index + 1].value !== 'Tire Storage Cost') {
          this.columns.splice(index + 1, 0, { name: 'Tire Storage Price', value: 'Tire Storage Price', isChecked: true });
          this.columns.splice(index + 2, 0, { name: 'Tire Storage Cost', value: 'Tire Storage Cost', isChecked: true });
          this.columns.splice(index + 3, 0, { name: 'Tire Storage Margin', value: 'Tire Storage Margin', isChecked: true });
        }
      }

      if (this.isSubletTrackingEnabled) {
        const index = findIndex(this.columns, { value: 'Tire Margin' });

        if (index > -1 && this.columns[index + 1] && this.columns[index + 1].value !== 'Sublet Cost') {
          this.columns.splice(index + 1, 0, { name: 'Sublet Price', value: 'Sublet Price', isChecked: true });
          this.columns.splice(index + 2, 0, { name: 'Sublet Cost', value: 'Sublet Cost', isChecked: true });
          this.columns.splice(index + 3, 0, { name: 'Sublet Margin', value: 'Sublet Margin', isChecked: true });
        }
      }
      this.fileName = 'profitability-report';
      this.downloadProfitabilityReport(this.filter);
    } else if (this.id === 'labor-reporting') {
      this.columns = this.allColumns.laborReport;
      this.fileName = 'labor-report';
      this.downloadLaborReport(this.filter);
    } else if (this.id === 'labor-reporting-drill-down') {
      this.columns = this.allColumns.laborReportDrillDown;
      if (this.isRevenueRecognitionSettleEnabled) {
        if (!find(this.columns, { value: this.columns.value })) {
          this.columns.splice(findIndex(this.columns, { value: 'invoiceDate' }), 1, this.finalizeColumn);
          this.columns.splice(findIndex(this.columns, { value: 'finalizeDate' }) + 1, 0, this.finalizeType);
        }
      }
      this.addMultilocationColumn('finalizeType', 'invoiceDate');
      this.fileName = 'labor-drilldown-report';
      this.downloadLaborDrillDownReport(this.filter);
    } else if (this.id === 'google-review') {
      this.columns = this.allColumns.googleReviews;
      const { isMultiLocationEnabled } = this.dataService;
      if (isMultiLocationEnabled) {
        this.columns.splice(2, 0, {
          value: 'shopId',
          name: 'Location',
          isChecked: true,
        });
      }
      this.fileName = 'google-review-report';
      this.downloadGoogleReview(this.filter);
    } else if (this.id === 'internal-survey') {
      this.columns = this.allColumns.internalSurveys;
      this.fileName = 'internal-survey-report';
      this.downloadInternalReview(this.filter);
    } else if (this.id === 'canned-service') {
      this.columns = this.allColumns.cannedService;
      if (this.isSubletTrackingEnabled) {
        const index = findIndex(this.columns, { value: 'Tire margin' });

        if (index > -1 && this.columns[index + 1] && this.columns[index + 1].value !== 'Sublet margin') {
          this.columns.splice(index + 1, 0, { name: 'Sublet value (margin)', value: 'Sublet margin', isChecked: true });
        }
      }
      this.fileName = 'services-invoiced-report';
      this.downloadCannedServices(this.filter);
    } else if (this.id === 'canned-service-detail') {
      this.columns = this.allColumns.cannedServiceDetails;
      if (this.isRevenueRecognitionSettleEnabled) {
        if (!find(this.columns, { value: this.columns.value })) {
          this.columns.splice(findIndex(this.columns, { value: 'Invoice date' }), 1, this.finalizeColumn);
          this.columns.splice(findIndex(this.columns, { value: 'finalizeDate' }) + 1, 0, this.finalizeType);
        }
      }
      this.addMultilocationColumn('finalizeType', 'Invoice date');
      if (this.isSubletTrackingEnabled) {
        const index = findIndex(this.columns, { value: 'Tire margin' });

        if (index > -1 && this.columns[index + 1] && this.columns[index + 1].value !== 'Sublet margin') {
          this.columns.splice(index + 1, 0, { name: 'Sublet value (margin)', value: 'Sublet margin', isChecked: true });
        }
      }
      this.fileName = 'canned-service-detail-report';
      this.downloadCannedDetailsServices(this.filter);
    } else if (this.id === 'customer') {
      this.columns = this.allColumns.customer;
      this.fileName = 'customer-report';
      this.downloadCustomer(this.filter);
    } else if (this.id === 'orders') {
      this.columns = this.allColumns.order;
      const { isMultiLocationEnabled } = this.dataService;
      if (isMultiLocationEnabled) {
        this.columns.splice(2, 0, {
          value: 'shopId',
          name: 'Location',
          isChecked: true,
        });
      }
      if (this.isPassThroughTaxEnable) {
        this.columns.splice(findIndex(this.columns, { value: 'Tax' }), 0, { name: 'Passthrough Tax', value: 'Passthrough Tax', isChecked: true });
      }
      this.fileName = 'order-report';
      this.downloadOrders(this.filter);
    } else if (this.id === 'outstanding-invoice') {
      this.columns = this.allColumns.outstandingInvoice;
      if (this.isRevenueRecognitionSettleEnabled) {
        if (!find(this.columns, { value: this.columns.value })) {
          this.columns.splice(findIndex(this.columns, { value: 'Invoiced Date' }), 1, this.finalizeColumn);
          this.columns.splice(findIndex(this.columns, { value: 'finalizeDate' }) + 1, 0, this.finalizeType);
        }
      }
      // const { isMultiLocationEnabled } = this.dataService;
      // if (isMultiLocationEnabled) {
      //   this.columns.splice(1, 0, {
      //     value: 'shopId',
      //     name: 'Location',
      //     isChecked: true,
      //   });
      // }
      this.addMultilocationColumn('finalizeType', 'Invoiced Date');
      this.fileName = 'outstanding-invoice-report';
      this.downloadOutstandingInvoice(this.filter);
    } else if (this.id === 'orderArByCustomer-invoice') {
      this.columns = this.allColumns.orderarbycustomer;
      this.fileName = 'orderArByCustomer-invoice-report';
      this.downloadAccountReceivable(this.filter);
    } else if (this.id === 'orderArMovement') {
      this.columns = this.allColumns.orderArMovement;
      this.fileName = 'orderArMovement-report';
      this.downloadArMovement(this.filter);
    } else if (this.id === 'daily-payment') {
      this.columns = this.allColumns.dailyPaymentReport;
      const { isMultiLocationEnabled } = this.dataService;
      if (isMultiLocationEnabled) {
        this.columns.splice(1, 0, {
          value: 'location',
          name: 'Location',
          isChecked: true,
        });
      }
      this.fileName = 'daily-payment-report';
      this.downloadDailyPaymentReport();
    } else if (this.id === 'all-payments') {
      this.columns = this.allColumns.allPayments;
      const { isMultiLocationEnabled } = this.dataService;
      if (isMultiLocationEnabled) {
        this.columns.splice(1, 0, {
          value: 'shopId',
          name: 'Location',
          isChecked: true,
        });
      }
      this.paymentStatsColumns = this.allColumns.allPaymentsStats;
      this.fileName = 'all-payments-report';
      this.paymentStatsFilename = 'all-payments-stats-report';
      this.downloadAllPayments(this.filter);
    } else if (this.id === 'technician-activity') {
      this.columns = this.allColumns.technicianActivity;
      const { isMultiLocationEnabled } = this.dataService;
      if (isMultiLocationEnabled) {
        this.columns.splice(1, 0, {
          value: 'shopId',
          name: 'Location',
          isChecked: true,
        });
      }
      this.fileName = 'technician-activity-report';
      this.downloadTechnicianActivity(this.filter);
    } else if (this.id === 'technician-summary') {
      this.columns = this.allColumns.technicianSummary;
      this.fileName = 'technician-summary-report';
      this.downloadTechnicianSummary(this.filter);
    } else if (this.id === 'technician-detail-reports') {
      this.columns = this.allColumns.techDetail;
      this.fileName = 'technician-drilldown-report';
      this.finalData.length = 1;
    } else if (this.id === 'technician-detail') {
      this.setSplitBillTechColumn();
      this.columns = this.allColumns.techDetail;
      this.fileName = 'technician-drilldown-report';
      this.checkTechDrilldownReport(this.filter);
      // this.finalData.length = 1;
    } else if (this.id === 'technician-summary-all-service') {
      this.columns = this.allColumns.techAllSummary;
      this.fileName = 'technician-summary-all-services-report';
      this.downloadTechnicianSummaryAllServices(this.filter);
    } else if (this.id === 'ap-supplier') {
      this.columns = this.allColumns.apSupplier;
      if (this.isSubletTrackingEnabled && this.dataService.isFilterOnSublet) {
        this.columns.splice(findIndex(this.columns, { value: 'paidPos' }), 1, { value: 'paidPos', name: 'Paid ROs', isChecked: true });
        this.columns.splice(findIndex(this.columns, { value: 'unpaidPos' }), 1, { value: 'unpaidPos', name: 'Unpaid ROs', isChecked: true });
      }
      this.fileName = 'acc-payable-supplier-report';
      this.downloadAccPayableSupplier(this.filter);
    } else if (this.id === 'ap-supplier-details') {
      this.columns = this.allColumns.apSupplierDetail;
      if (this.isSubletTrackingEnabled && this.query?.isFilterOnSublet === '1') {
        this.columns.splice(findIndex(this.columns, { value: 'code' }), 1, { value: 'code', name: 'RO#', isChecked: true });
        this.columns.splice(findIndex(this.columns, { value: 'code' }) + 1, 0, { value: 'name', name: 'Name', isChecked: true });
      }
      this.fileName = 'acc-payable-supplier-details-report';
      this.downloadAccPayableSupplierDetails(this.filter);
    } else if (this.id === 'technician-summary-reports-all-service-details') {
      this.columns = this.allColumns.techAllSummaryDetail;
      if (this.isRevenueRecognitionSettleEnabled) {
        if (!find(this.columns, { value: this.columns.value })) {
          this.columns.splice(findIndex(this.columns, { value: 'invoiceDate' }), 1, this.finalizeColumn);
          this.columns.splice(findIndex(this.columns, { value: 'finalizeDate' }) + 1, 0, this.finalizeType);
        }
      }
      this.addMultilocationColumn('finalizeType', 'invoiceDate');
      this.fileName = 'tech-summary-all-services-report';
      this.downloadTechnicianSummaryAllServicesDetails(this.filter);
    } else if (this.id === 'technician-attendance-log-details') {
      this.columns = this.allColumns.attendanceLogDetail;
      this.fileName = 'technician-attendance-log-details';
      this.downloadAttendanceLogDetails(this.filter);
    } else if (this.id === 'royalty') {
      this.columns = this.allColumns.royaltyFeeList;
      this.fileName = 'royalty-report';
      this.downloadRoyaltyReport(this.filter);
    } else if (this.id === 'inventory-activity-reports') {
      this.columns = this.allColumns.inventoryActivity;
      this.fileName = 'inventory-activity-reports';
      this.downloadInventoryLogs(this.filter);
    } else if (this.id === 'inventory-level-reports') {
      this.columns = this.allColumns.inventoryLevel;
      const uniqueItemTitleColumn = { name: 'Number', value: 'code', isChecked: true };
      if (!find(this.columns, { value: uniqueItemTitleColumn.value })) {
        this.columns.splice(findIndex(this.columns, { value: 'itemName' }) + 1, 0, uniqueItemTitleColumn);
      }
      if (this.dataService.isMultiLocationEnabled) {
        if (!find(this.columns, { value: 'countTransit' })) {
          this.columns.splice(findIndex(this.columns, { value: 'countOnEstimate' }), 1, { name: 'Qty in transit', value: 'countTransit', isChecked: false });
        }
        if (!find(this.columns, { value: 'stockInTransitValue' })) {
          this.columns.splice(findIndex(this.columns, { value: 'stockValue' }), 1, { name: 'Stock in transit value', value: 'stockInTransitValue', isChecked: true });
        }
      }
      this.fileName = 'inventory-level-reports';
      this.downloadInventoryLevelReport(this.filter);
    } else if (this.id === 'tax-rate-drilldown') {
      this.columns = this.allColumns.taxRateDrilldown;
      if (this.isRevenueRecognitionSettleEnabled) {
        if (!find(this.columns, { value: this.columns.value })) {
          this.columns.splice(findIndex(this.columns, { value: 'invoiceDate' }), 1, this.finalizeColumn);
          this.columns.splice(findIndex(this.columns, { value: 'finalizeDate' }) + 1, 0, this.finalizeType);
        }
      }
      this.addMultilocationColumn('finalizeType', 'invoiceDate');
      this.fileName = 'tax-rate-drilldown';
      this.downloadTaxDrilldown(this.filterState);
    } else if (this.id === 'tax-report') {
      this.columns = this.allColumns.taxReport;
      if (this.dataService.isCountTaxExemptROAsNonTaxedEnable) {
        this.columns.forEach((item) => {
          if (item.value === 'nonTaxableAmount') {
            item.name = 'Non-taxed amount';
          }

          if (item.value === 'taxableAmount') {
            item.name = 'Taxed amount';
          }
        });
      }
      this.fileName = 'tax-report';
      this.donwloadTaxReport(this.filterState);
    } else if (this.id === 'item-sold-report') {
      this.columns = this.allColumns.itemSoldReport;
      this.fileName = 'item-sold-report';
      this.downloadItemSoldReport(this.filter);
    } else if (this.id === 'items-enhance-item-sold' && !this.isDrillDown) {
      // **Copy the updated array first**
      let updatedColumns = [...this.allColumns.itemSoldReportEnhancement];

      // **Apply conditional filters for dynamic column selection**
      const conditionalColumns = [
        { key: 'itemCategory', condition: this.isNewItemCategoriesEnable },
        // { key: 'serviceWriter', condition: this.isServiceWriterEnabled },
        // { key: 'inventoryItem', condition: this.isInventoryFeatureEnabled }
      ];

      // **Filter out columns based on conditions**
      updatedColumns = updatedColumns.filter((col) => {
        const conditionCheck = conditionalColumns.find((cond) => cond.key === col.value);
        return conditionCheck ? conditionCheck.condition : true; // Keep column if no condition exists
      });

      this.columns = updatedColumns;

      // **Ensure Sales Group & Sales Code are added correctly**
      if (this.isSalesCodeEnabled && !find(this.columns, { value: 'salesCode' })) {
        const index = findIndex(this.columns, { value: 'itemCategory' });
        this.columns.splice(index + 1, 0, { name: 'Sales group', value: 'salesGroup', isChecked: false });
        this.columns.splice(index + 2, 0, { name: 'Sales code', value: 'salesCode', isChecked: false });
      }

      // **Sync isChecked from selectedColumns**
      this.columns = this.columns.map((col) => {
        const matchingColumn = selectedColumns.find((expCol) => expCol.field === col.value);
        return matchingColumn ? { ...col, isChecked: matchingColumn.isChecked } : col;
      });

      this.fileName = 'items-enhance-item-sold';
      this.downloadItemSoldReportEnhancement(this.filter);
    } else if (this.id === 'supplier-summary-reports') {
      if (this.isSupplierReportEnabled) {
        this.columns = this.allColumns.updatedSupplierReport;
      } else {
        this.columns = this.allColumns.supplierReport;
      }
      this.fileName = 'supplier-report';
      this.downloadSupplierReport(this.filter);
    } else if (this.id === 'supplier-details') {
      this.fileName = 'supplier-details-report';
      if (this.isSupplierReportEnabled) {
        this.columns = supplierDrillDownCSV;
        this.downloadSupplierDetailsSummaryReport(this.filter);
      } else {
        this.columns = this.allColumns.supplierDetails;
        this.downloadSupplierDetailsReport(this.filter);
      }
      if (!find(this.columns, { value: 'supplierInvNum' })) {
        if (this.dataService.isMultiLocationEnabled) {
          const rosindex = findIndex(this.columns, { value: 'ros' });
          this.columns.splice(rosindex + 1, 0, ...locationReportColumnsCVS);
          const posindex = findIndex(this.columns, { value: 'pos' });
          this.columns.splice(posindex + 1, 0, { name: 'Supplier Invoice #', value: 'supplierInvNum', isChecked: true });
        } else {
          const posindex = findIndex(this.columns, { value: 'pos' });
          this.columns.splice(posindex, 0, { name: 'Supplier Invoice #', value: 'supplierInvNum', isChecked: true });
        }
      }
    } else if (this.id === 'breakdown-tax-report') {
      this.columns = this.allColumns.breakdownTaxReport;
      if (this.dataService.isCountTaxExemptROAsNonTaxedEnable) {
        this.columns.forEach((item) => {
          if (item.value === 'nonTaxableAmt') {
            item.name = 'Non-taxed amount';
          }

          if (item.value === 'taxableAmt') {
            item.name = 'Taxed amount';
          }
        });
      }
      this.fileName = 'tax-item-report';
      this.downloadTaxItemReport(this.filter);
    } else if (this.id === 'breakdowan-tax-details') {
      this.columns = this.allColumns.breakdownTaxDetailsReport;
      if (this.dataService.isCountTaxExemptROAsNonTaxedEnable) {
        this.columns.forEach((item) => {
          if (item.value === 'nonTaxAbleAmt') {
            item.name = 'Non-taxed amount';
          }

          if (item.value === 'taxAbleAmt') {
            item.name = 'Taxed amount';
          }
        });
      }
      const { isMultiLocationEnabled } = this.dataService;
      if (isMultiLocationEnabled && !find(this.columns, { value: 'shopId' })) {
        this.columns.splice(findIndex(this.columns, { value: 'roCode' }) + 1, 0, {
          value: 'shopId',
          name: 'Location',
          isChecked: true,
        });
      }

      this.fileName = 'tax-item--detail-report';
      this.downloadTaxItemDetailsReport(this.filter);
    } else if (this.id === 'item-detail-report') {
      this.columns = this.allColumns.itemDetailsReport;
      if (this.isRevenueRecognitionSettleEnabled) {
        if (!find(this.columns, { value: this.columns.value })) {
          this.columns.splice(findIndex(this.columns, { value: 'invoiceDate' }), 1, this.finalizeColumn);
          this.columns.splice(findIndex(this.columns, { value: 'finalizeDate' }) + 1, 0, this.finalizeType);
        }
      }
      this.addMultilocationColumn('finalizeType', 'invoiceDate');
      this.fileName = 'item-details-report';
      this.downloadItemDetailsReport(this.filter);
    } else if (this.id === 'fee-report') {
      this.columns = this.allColumns.feeReport;
      this.fileName = 'fee-summary-report';
      this.downloadFeeSummaryReport(this.filter);
    } else if (this.id === 'fee-detail-report') {
      this.columns = this.allColumns.feeItemDrillDown;
      if (this.isRevenueRecognitionSettleEnabled) {
        if (!find(this.columns, { value: this.columns.value })) {
          this.columns.splice(findIndex(this.columns, { value: 'invoiceDate' }), 1, this.finalizeColumn);
          this.columns.splice(findIndex(this.columns, { value: 'finalizeDate' }) + 1, 0, this.finalizeType);
        }
      }
      this.addMultilocationColumn('finalizeType', 'invoiceDate');
      this.fileName = 'fee-detail-report';
      this.downloadFeeItemReport(this.filter);
    } else if (this.id === 'order-discount-report') {
      this.columns = this.allColumns.discountDrillDown;
      const { isMultiLocationEnabled } = this.dataService;
      if (isMultiLocationEnabled && !find(this.columns, { value: 'shopId' })) {
        this.columns.splice(findIndex(this.columns, { value: 'appliedOn' }) + 1, 0, {
          value: 'shopId',
          name: 'Location',
          isChecked: true,
        });
      }
      this.fileName = 'order-discount-report';
      this.downloadDiscountItemReport(this.filter);
    } else if (this.id === 'discount-reporting') {
      this.columns = this.allColumns.discountSummaryReport;
      this.fileName = 'discount-reporting';
      this.downloadDiscountSummaryReport(this.filter);
    } else if (this.id === 'commission-report') {
      this.columns = this.allColumns.commissionSummaryReport;
      this.fileName = 'commission-report';
      this.downloadCommissionReport(this.filter);
    } else if (this.id === 'commission-detail-report') {
      this.columns = this.allColumns.commissionDetailReport;
      this.fileName = 'commission-drilldown-report';
      this.downloadCommissionDrillDownReport(this.filter);
    } else if (this.id === 'unsued-items') {
      this.columns = this.allColumns.unusedReport;
      this.fileName = 'unused-item-report';
      this.downloadUnusedItemReport(this.filter);
    } else if (this.id === 'orderApMovement') {
      this.columns = this.allColumns.itemMovmentsColumns;

      const { isRevenueRecognitionSettleEnabled } = this.helperService.getCompany();
      if (isRevenueRecognitionSettleEnabled) {
        this.columns.splice(findIndex(this.columns, { value: 'deliveryDate' }) + 1, 0, this.finalizeColumn);
      }
      this.fileName = 'order-ap-movement-report';
      this.downloadAPMovementData(this.filter);
    } else if (this.id === 'warranties') {
      this.columns = this.allColumns.warrantyReport;
      this.fileName = 'warranties-report';
      this.downloadWarrantiesReport(this.filter);
    } else if (this.id === 'items-enhance-item-sold-detail') {
      // **Sync isChecked from selectedColumns**
      this.allColumns.itemSoldDrilldown = this.allColumns.itemSoldDrilldown.map((col) => {
        const matchingColumn = selectedColumns.find((expCol) => expCol.field === col.value);
        return matchingColumn ? { ...col, isChecked: matchingColumn.isChecked } : col;
      });

      // **Copy the updated array first**
      this.columns = [...this.allColumns.itemSoldDrilldown];

      // **Apply dynamic conditions**
      if (this.isRevenueRecognitionSettleEnabled && this.data.isFinalize) {
        if (!find(this.columns, { value: 'finalizeDate' })) {
          const finalizeSelected = selectedColumns.some((expCol) => expCol.field === 'finalizeDate' && expCol.isChecked);
          const finalizeTypeSelected = selectedColumns.some((expCol) => expCol.field === 'finalizeType' && expCol.isChecked); // Fix applied here

          this.columns.splice(findIndex(this.columns, { value: 'invoiceDate' }) + 1, 0, { ...this.finalizeColumn, isChecked: finalizeSelected });

          // **Only add finalizeType if it was selected in selectedColumns**
          if (finalizeTypeSelected) {
            this.columns.splice(findIndex(this.columns, { value: 'finalizeDate' }) + 1, 0, { ...this.finalizeType, isChecked: finalizeTypeSelected });
            this.paramFilters.dateType = 'finalizeDate';
          }
        }
      }

      if (this.isRevenueRecognitionSettleEnabled && this.data.isFinalize) {
        // Remove 'invoiceDate' column if it exists
        const invoiceDateIndex = findIndex(this.columns, { value: 'invoiceDate' });
        if (invoiceDateIndex !== -1) {
          this.columns.splice(invoiceDateIndex, 1);
        }
      } else {
        // Ensure 'invoiceDate' is added back if it doesn't exist
        if (findIndex(this.columns, { value: 'invoiceDate' }) === -1) {
          this.columns.push({
            name: 'Invoice Date',
            value: 'invoiceDate',
            isChecked: true,
          });
        }
      }

      if ((this.data.drilldownItemType === 'part' || this.data.drilldownItemType === 'tire') && !find(this.columns, { value: 'source' })) {
        const sourceSelected = selectedColumns.some((expCol) => expCol.field === 'source' && expCol.isChecked);
        const index = findIndex(this.columns, { value: 'supplier' });
        this.columns.splice(index + 1, 0, { name: 'Source', value: 'source', isChecked: sourceSelected });
      }

      if (this.isSalesCodeEnabled && !find(this.columns, { value: 'salesCode' })) {
        const salesGroupSelected = selectedColumns.some((expCol) => expCol.field === 'salesGroup' && expCol.isChecked);
        const salesCodeSelected = selectedColumns.some((expCol) => expCol.field === 'salesCode' && expCol.isChecked);

        const sourceIndex = findIndex(this.columns, { value: 'source' });
        const supplierIndex = findIndex(this.columns, { value: 'supplier' });
        const index = sourceIndex === -1 ? supplierIndex : sourceIndex;

        this.columns.splice(index + 1, 0, { name: 'Sales group', value: 'salesGroup', isChecked: salesGroupSelected });
        this.columns.splice(index + 2, 0, { name: 'Sales code', value: 'salesCode', isChecked: salesCodeSelected });
      }

      // **Ensure dynamically added tire columns respect selectedColumns' isChecked values**
      if (this.data.drilldownItemType === 'tire') {
        let tireColumns = this.itemSoldDrilldownTiresColumns.map((col) => {
          const matchingColumn = selectedColumns.find((expCol) => expCol.field === col.value);
          return matchingColumn ? { ...col, isChecked: matchingColumn.isChecked } : col;
        });

        // **Add `Warranty` column if `isTireWarrantyPolicyEnabled` or `isPartWarrantiesEnabled` is true**
        if (this.isTireWarrantyPolicyEnabled || this.isPartWarrantiesEnabled) {
          const warrantySelected = selectedColumns.some((expCol) => expCol.field === 'warranty' && expCol.isChecked);

          // Ensure `warrantyColumn` is not already in `tireColumns`
          if (!tireColumns.some((col) => col.value === 'warranty')) {
            tireColumns.push({
              name: 'Warranty',
              value: 'warranty',
              isShowSortIcon: false,
              class: 'customerName',
              isChecked: warrantySelected,
            });
          }
        }

        this.columns.splice(this.columns.length, 0, ...tireColumns);
      }

      // **Get all checked columns**
      // const checkedColumns = this.columns.filter(col => col.isChecked).map(col => col.value);

      // console.log("Checked Columns:", checkedColumns);

      this.fileName = 'item-sold-details-report';
      this.downloadItemSoldDetailsReport(this.filter);
    } else if (this.id === 'items-enhance-item-sold' && this.isDrillDown) {
      // **Copy the updated array first**
      let itemSoldAndDetailsColumns = this.helperService.deepCopy(this.allColumns.itemSoldDrilldown);
      // const itemSoldAndDetailsColumns = this.helperService.deepCopy(this.allColumns.itemSoldDrilldown);
      //  this.allColumns.itemSoldDrilldown;
      // itemSoldAndDetailsColumns.unshift(
      //   { name: 'Item type', value: 'itemType', isChecked: true },
      //   { name: 'Item name', value: 'itemName', isChecked: true },
      //   { name: 'Item number', value: 'itemNumber', isChecked: true },
      // )
      this.columns = itemSoldAndDetailsColumns;
      if (this.isRevenueRecognitionSettleEnabled && this.data.isFinalize) {
        if (!find(this.columns, { value: this.columns.value })) {
          this.columns.splice(findIndex(this.columns, { value: 'invoiceDate' }), 1, this.finalizeColumn);
          this.columns.splice(findIndex(this.columns, { value: 'finalizeDate' }) + 1, 0, this.finalizeType);
        }
      }

      if (this.data.drilldownItemType === 'part' || (this.data.drilldownItemType === 'tire' && !find(this.columns, { value: 'source' }))) {
        const index = findIndex(this.columns, { value: 'supplier' });
        this.columns.splice(index + 1, 0, { name: 'Source', value: 'source', isChecked: false });
      }

      if (this.isSalesCodeEnabled && !find(this.columns, { value: 'salesCode' })) {
        // const index = findIndex(this.columns, { value: 'subTotalCost' });
        const sourceIndex = findIndex(this.columns, { value: 'source' });
        const supplierIndex = findIndex(this.columns, { value: 'supplier' });
        const index = sourceIndex === -1 ? supplierIndex : sourceIndex;

        this.columns.splice(index + 1, 0, { name: 'Sales group', value: 'salesGroup', isChecked: false });
        this.columns.splice(index + 2, 0, { name: 'Sales code', value: 'salesCode', isChecked: false });
      }

      if (find(this.columns, { value: 'profitability' })) {
        const index = findIndex(this.columns, { value: 'profitability' });
        this.columns[index].value = 'avgprofatibilty';
      }

      if (find(this.columns, { value: 'updatedprofitability' })) {
        const index = findIndex(this.columns, { value: 'updatedprofitability' });
        this.columns[index].value = 'profitability';
      }

      // **Sync isChecked from selectedColumns**
      this.columns = this.columns.map((col) => {
        const matchingColumn = selectedColumns.find((expCol) => expCol.field === col.value);
        return matchingColumn ? { ...col, isChecked: matchingColumn.isChecked } : col;
      });

      if (this.data.drilldownItemType === 'tire') {
        // Map tire columns to match selectedColumns' isChecked values
        let tireColumns = this.itemSoldDrilldownTiresColumns.map((col) => {
          const matchingColumn = selectedColumns.find((expCol) => expCol.field === col.value);
          return matchingColumn ? { ...col, isChecked: matchingColumn.isChecked } : col;
        });

        // **Add `Warranty` column if `isTireWarrantyPolicyEnabled` or `isPartWarrantiesEnabled` is true**
        if (this.isTireWarrantyPolicyEnabled || this.isPartWarrantiesEnabled) {
          const warrantySelected = selectedColumns.some((expCol) => expCol.field === 'warranty' && expCol.isChecked);

          // Ensure `warrantyColumn` is not already present in `tireColumns`
          if (!tireColumns.some((col) => col.value === 'warranty')) {
            tireColumns.push({
              name: 'Warranty',
              value: 'warranty',
              isShowSortIcon: false,
              class: 'customerName',
              isChecked: warrantySelected,
            });
          }
        }

        // Append the processed tire columns to `this.columns`
        this.columns.splice(this.columns.length, 0, ...tireColumns);
      }

      this.fileName = 'item-sold-details-report';
      this.downloadItemSoldReportEnhancement(this.filter);
    }
  }

  addMultilocationColumn(firstColValue: string, secondColValue: string) {
    const { isMultiLocationEnabled } = this.dataService;
    if (isMultiLocationEnabled && !find(this.columns, { value: 'shopId' })) {
      if (this.isRevenueRecognitionSettleEnabled) {
        this.columns.splice(findIndex(this.columns, { value: firstColValue }) + 1, 0, {
          value: 'shopId',
          name: 'Location',
          isChecked: true,
        });
      } else {
        this.columns.splice(findIndex(this.columns, { value: secondColValue }) + 1, 0, {
          value: 'shopId',
          name: 'Location',
          isChecked: true,
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.dataServiceSubscription?.unsubscribe();
  }

  setDataService() {
    this.isTireStorageEnabled = this.dataService.isTireStorageEnabled;
    this.isMidasEnabled = this.dataService.isMidasRoyaltyReportsEnable;
    this.baseTax = this.dataService.baseTax;
    this.taxType = this.dataService.taxType;
    this.isExportedToReturn = this.dataService.isExportedToReturn;

    this.dataServiceSubscription = this.dataService.getData().subscribe(({ data }) => {
      if (data && data.key === 'company-appdata-updated') {
        this.isTireStorageEnabled = this.dataService.isTireStorageEnabled;
        this.isMidasEnabled = this.dataService.isMidasRoyaltyReportsEnable;
        this.isExportedToReturn = this.dataService.isExportedToReturn;

        this.baseTax = this.dataService.baseTax;
        this.taxType = this.dataService.taxType;
        this.setFeaturedFlag();
        this.dataServiceSubscription.unsubscribe();
      }
    });

    this.setFeaturedFlag();
  }

  setFeaturedFlag() {
    let index: number;
    if (this.isTireStorageEnabled) {
      //let index: number;

      if (this.id === 'sales' && !this.filterState.isPrint) {
        if (findIndex(this.columns, { value: 'Tire storage amount' }) === -1) {
          index = findIndex(this.columns, { value: 'Tire amount' });
          this.columns.splice(index + 1, 0, { name: 'Tire storage amount', value: 'Tire storage amount', isChecked: true });
        }
      } else if (this.id === 'orders') {
        if (findIndex(this.columns, { value: 'Tire storage price' }) === -1) {
          index = findIndex(this.columns, { value: 'Tire price' });
          this.columns.splice(index + 1, 0, { name: 'Tire storage price', value: 'Tire storage price', isChecked: true });
        }
      } else if (this.id === 'profitability') {
        if (findIndex(this.columns, { value: 'Tire storage price' }) === -1) {
          index = findIndex(this.columns, { value: 'Tire Margin' });
          this.columns.splice(index + 1, 0, { name: 'Tire Storage Price', value: 'Tire Storage Price', isChecked: true });
          this.columns.splice(index + 2, 0, { name: 'Tire Storage Cost', value: 'Tire Storage Cost', isChecked: true });
          this.columns.splice(index + 3, 0, { name: 'Tire Storage Margin', value: 'Tire Storage Margin', isChecked: true });
        }

        if (findIndex(this.columns, { value: 'Tire storage line discount' }) === -1) {
          index = findIndex(this.columns, { value: 'Tire line discount' });
          this.columns.splice(index + 1, 0, {
            name: 'Tire storage line discount',
            value: 'Tire storage line discount',
            isChecked: true,
          });
        }
      }
    }

    if (['all', true, false].includes(this.isExportedToReturn)) {
      const index = findIndex(this.columns, { value: 'inventoryBalance' });
      if (this.id === 'orderApMovement') {
        if (this.columns[index + 1]?.value !== 'isExportedToReturn') {
          this.columns.splice(index + 1, 0, { name: 'Exported to accounting', value: 'isExportedToReturn', isChecked: true });
        }
      }
    }

    if (this.isMidasEnabled) {
      const index = findIndex(this.columns, { value: 'noOfOperations' });
      if (this.id === 'royalty') {
        if (this.columns[index + 1].value !== 'employeeSales') {
          this.columns.splice(index + 1, 0, { name: 'Employee Sales', value: 'employeeSales', isChecked: true });
        }

        if (this.columns[index + 2].value !== 'nationalFleetSales') {
          this.columns.splice(index + 2, 0, { name: 'National Fleet Sales', value: 'nationalFleetSales', isChecked: true });
        }
      }
    }

    if (this.id === 'inventory-activity-reports') {
      if (findIndex(this.columns, { value: 'itemCode' }) === -1) {
        index = findIndex(this.columns, { value: 'itemName' });
        this.columns.splice(index + 1, 0, { name: 'Number', value: 'itemCode', isChecked: true });
      }
    } else if (this.id === 'inventory-level-reports') {
      if (findIndex(this.columns, { value: 'code' }) === -1) {
        index = findIndex(this.columns, { value: 'itemName' });
        this.columns.splice(index + 1, 0, { name: 'Number', value: 'code', isChecked: true });
      }
    } else if (this.id === 'unsued-items') {
      if (findIndex(this.columns, { value: 'partNumber' }) === -1) {
        index = findIndex(this.columns, { value: 'type' });
        this.columns.splice(index + 1, 0, { name: 'Item number', value: 'partNumber', isChecked: true });
      }
    } else if (this.id === 'breakdowan-tax-details' && this.taxType === 'part') {
      if (findIndex(this.columns, { value: 'itemNumber' }) === -1) {
        index = findIndex(this.columns, { value: 'name' });
        this.columns.splice(index + 1, 0, { name: 'Number', value: 'itemNumber', isChecked: true });
      }
    } else if (this.id === 'item-sold-report') {
      if (findIndex(this.columns, { value: 'itemNumber' }) === -1) {
        index = findIndex(this.columns, { value: 'itemName' });
        this.columns.splice(index + 1, 0, { name: 'Item number', value: 'itemNumber', isChecked: true });
      }
    }
  }

  handleCheckChange(colIndex: string, isChecked: boolean) {
    this.columns[colIndex].isChecked = isChecked;
  }

  handleChange(isChecked) {
    this.isFiltersApply = isChecked;
  }

  closeModal() {
    this.dynamicDialogRef.close({
      isSuccess: false,
    });
  }

  handlePrint = () => {
    this.paramFilters.isFiltersApply = this.isFiltersApply;
    if (this.dataService.finalizeFilterBy) {
      this.paramFilters.finalizationTypeList = JSON.stringify(this.dataService.finalizationTypeList);
    }
    this.paramFilters.shopsMap = JSON.stringify(this.dataService.shopsMap);
    const columns = this.helperService.deepCopy(this.columns).filter((e: any) => e.isChecked);
    let downloadData = [];
    const d = {};
    columns.forEach((n: any) => (d[n.value] = true));
    downloadData.push(d);
    this.paramFilters.isPreview = true;
    this.paramFilters.downloadData = JSON.stringify(downloadData);
    this.paramFilters.isSubletTrackingEnabled = this.isSubletTrackingEnabled;
    this.paramFilters.isPassThroughTaxEnable = this.isPassThroughTaxEnable;
    let url = '';
    if (this.filterState.id === 'sales') {
      url = this.router.serializeUrl(this.router.createUrlTree([`/print-view/sales-report/`], { queryParams: this.paramFilters }));
    } else if (this.filterState.id === 'daily-payment') {
      url = this.router.serializeUrl(this.router.createUrlTree([`/print-view/daily-payment-report/`], { queryParams: this.paramFilters }));
    } else if (this.filterState.id === 'items-enhance-item-sold-detail') {
      this.paramFilters.dateType = this.data.isFinalize ? 'finalizeDate' : 'invoiceDate';
      url = this.router.serializeUrl(this.router.createUrlTree([`/print-view/item-sold-details-report-print/`], { queryParams: this.paramFilters }));
    } else if (this.filterState.id === 'items-enhance-item-sold') {
      // enhance-item-sold-print
      url = this.router.serializeUrl(this.router.createUrlTree([`/print-view/enhance-item-sold-print/`], { queryParams: this.paramFilters }));
    }
    this.closeModal();
    this.helperService.openPageInNewTab(url);
  };

  async downloadExcel() {
    if (this.id === 'technician-detail') {
      this.downloadTechnicianDrillDown(this.filter);
      this.dynamicDialogRef.close({ isSuccess: true });
      return;
    }

    // this.finalData.every((x) => (x.itemType = this.labels[x.itemType]));
    let downloadData = [];
    const columns = this.helperService.deepCopy(this.columns).filter((e: any) => e.isChecked);
    let data = this.helperService.deepCopy(this.finalData);

    data.forEach((obj) => {
      if (obj.hasOwnProperty('Sales Tax')) {
        obj['Sales Tax'] = obj['Sales Tax'].toFixed(2);
      }

      if (obj.hasOwnProperty('Amount remaining')) {
        obj['Amount remaining'] = obj['Amount remaining'].toFixed(2);
      }
    });

    if (['tax-report', 'tax-rate-drilldown'].includes(this.id)) {
      // downloadData = this.finalData;
      data.forEach((e: any) => {
        const d = {};
        columns.forEach((n: any) => (d[n.name] = e[n.name]));
        downloadData.push(d);
      });
    } else if (['daily-payment'].includes(this.id)) {
      data.forEach((e: any) => {
        if (e.type === 'daily') {
          const d = {};
          columns.forEach((n: any) => {
            if (n.value === 'Invoice') {
              n.value = 'roNumber';
            } else if (n.value === 'customerType') {
              n.value = 'isFleetCustomer';
            } else if (n.value === 'amount') {
              n.value = 'paid';
            }
            d[n.name] = e[n.value] || '';
          });
          downloadData.push(d);
        } else {
          const d = {};
          columns.forEach((n: any) => (d[n.name] = e[n.value] || ''));
          downloadData.push(d);
        }
      });
    } else {
      data.forEach((e: any) => {
        const d: any = {};
        columns.forEach((n: any) => {
          if (n.value === 'customer.displayName') {
            n.value = 'customerName';
          } else if (n.value === 'vehicle.name') {
            n.value = 'vehicleName';
          } else if (n.value === 'customer.email') {
            n.value = 'customerEmail';
          } else if (n.value === 'customer.phone') {
            n.value = 'customerPhone';
          }
          d[n.name] = e[n.value] ? e[n.value] : '';
        });
        if (d && d.Profitability) {
          // d.Profitability = `${d.Profitability}%`
          // d.Profitability = this.calculationService.roundOffToDecimalPlaces(d.Profitability) || '';
          d.Profitability = `${d.Profitability}` || '';
        }
        downloadData.push(d);
      });
    }

    this.exportService.JSONToCSVConvertor(downloadData, this.fileName, true, this.currentServerTime);
    this.dynamicDialogRef.close({ isSuccess: true });

    if (this.id === 'all-payments') {
      this.downloadAllPaymentsStats(this.filter);
      return;
    }
  }

  downloadItemDetailsReport(filter) {
    const { date = {}, supplier = { selected: [] }, shopIds = { shopIds: [] }, serviceWriter = {} } = filter;
    const tableConfig: any = {};
    tableConfig._id = this.activatedRoute.snapshot.params['id'];

    const { isMultiLocationEnabled } = this.helperService.getCompany();
    if (isMultiLocationEnabled && (!shopIds || (shopIds && !shopIds.length))) return;

    if (filter.date.startDate && filter.date.endDate) {
      tableConfig.startDate = filter.date.startDate;
      tableConfig.endDate = filter.date.endDate;

      if (supplier && supplier.selected && supplier.selected.length) {
        tableConfig.supplier = supplier.selected.map(({ name }) => name);
      } else {
        tableConfig.supplier = [];
      }
    }

    if (serviceWriter) {
      tableConfig.serviceWriter = serviceWriter.id;
    } else {
      tableConfig.serviceWriter = null;
    }

    if (this.isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoiceDate';
    }

    if (shopIds.length > 0) {
      tableConfig.shopIds = shopIds;
    } else {
      tableConfig.shopIds = '';
    }

    tableConfig.searchQuery = this.dataService.searchRoNumber;
    this.processing = true;
    this.httpService.getItemsReportSummaryById(tableConfig).then(
      (data: any) => {
        this.finalData = this.formatService.formatItemsRecordsList(data[0].records);
        if (this.finalData && this.finalData.length && this.finalData[0].itemType === 'tire')
          this.allColumns.itemDetailsReport.splice(12, 0, { name: 'Dot Number', value: 'dotNumber', isChecked: true });
        // let dotnumber = '';
        if (this.finalData.length) {
          this.finalData.forEach((element) => {
            if (element.dotNumbers) {
              element.dotNumber = '';
              element.dotNumbers.forEach((dot, i) => {
                element.dotNumber = `${element.dotNumber}${dot.dotNumber} ${dot.tirePosition ? '- ' + dot.tirePosition : ''}${i !== this.finalData[0].dotNumbers.length - 1 ? '\n' : ''}`;
              });
            }
          });
        }

        if (data[0].extras[0]) {
          const { cost, markup, price, profitability, tax, totalQuantitySold, totalSalesValue, discount } = data[0].extras[0];
          let obj = {
            cost: `${this.calculationService.roundOff(cost)}`,
            markup: `${this.calculationService.roundOff(markup)}`,
            price: `${this.calculationService.roundOff(price)}`,
            quantity: totalQuantitySold,
            tax: tax,
            discount: discount,
            subTotal: totalSalesValue,
            // profitability: (profitability * 100).toFixed(2),
            profitability: `${this.calculationService.roundOffToDecimalPlaces(profitability)}%`,
          };
          // if(this.finalData[0].dotNumbers) this.finalData[0].dotNumber = dotnumber;
          this.finalData = [obj].concat(this.finalData);
        }
        this.processing = false;
        if (isMultiLocationEnabled) {
          this.mapMultilocationShop();
        }
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  downloadTaxItemDetailsReport(filter: any) {
    const tableConfig: any = {};
    tableConfig.sortOrder = 1;
    tableConfig.drilldown = true;
    const { date = {}, paidStatus = {}, taxCode = {}, taxItemType = { selected: [] }, shopIds = { shopIds: [] } } = filter;
    this.setDataService();
    // Don't make call if date is missing
    if (!date.startDate || !date.endDate) return;
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    if (isMultiLocationEnabled && (!shopIds || (shopIds && !shopIds.length))) return;

    if (paidStatus) {
      const { paid = false, partiallyPaid = false, unPaid = false } = paidStatus;

      if (Array.from(new Set([paid, partiallyPaid, unPaid])).length > 1) {
        tableConfig.paidStatus = { paid, partiallyPaid, unPaid };
      }
    } else {
      delete tableConfig.paidStatus;
    }

    if (taxCode && taxCode._id) {
      tableConfig.taxCode = taxCode._id;
    } else {
      delete tableConfig.taxCode;
    }

    if (taxItemType && taxItemType.selected && taxItemType.selected.length) {
      tableConfig.type = taxItemType.selected.map(({ id }) => id);
    } else {
      tableConfig.type = this.activatedRoute.snapshot.params['id'];
    }

    if (this.isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoiceDate';
    }

    if (!this.baseTax) {
      tableConfig.paymentDateStart = date.startDate;
      tableConfig.paymentDateEnd = date.endDate;
      delete tableConfig.invoiceDateStart;
      delete tableConfig.invoiceDateEnd;
    } else if (this.dataService.baseTax) {
      delete tableConfig.paymentDateStart;
      delete tableConfig.paymentDateEnd;

      tableConfig.invoiceDateStart = date.startDate;
      tableConfig.invoiceDateEnd = date.endDate;
    }

    if (shopIds.length > 0) {
      tableConfig.shopIds = shopIds;
    } else {
      tableConfig.shopIds = '';
    }

    this.processing = true;
    this.httpService.getTaxReportByItemType(tableConfig, this.taxType).then((data: any) => {
      if (data && data.records) {
        this.finalData = this.formatService.formatTaxDetailsByTypeList(data.records);
        if (isMultiLocationEnabled) {
          this.mapMultilocationShop();
        }
      }
      this.processing = false;
    });
  }

  downloadTaxItemReport(filter: any) {
    let tableConfig: any = {};
    const { isMultiLocationEnabled, isRevenueRecognitionSettleEnabled } = this.helperService.getCompany();
    const { shopIds = [], date = {} } = filter;
    this.setDataService();

    // Don't make call if date is missing
    if (!date.startDate || !date.endDate) return;
    if (isMultiLocationEnabled && (!shopIds || (shopIds && !shopIds.length))) return;

    tableConfig = { ...tableConfig, ...this.formatService.formatTaxItemReportFilter(filter, this.baseTax) };

    if (this.dataService.isFilterByFinalizeDate) {
      tableConfig.dateType = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoiceDate';
    }

    tableConfig.finalizeType = this.dataService.finalizeType;
    tableConfig.dateTitle = this.dataService.dateTitle;
    tableConfig.thirdPartyAccount = this.dataService.thirdPartyAccount;

    if (this.filter?.genericFilter && this.filter?.genericFilter?.selected?.length) {
      this.setFinalizeTypeFilter(this.filter.genericFilter.selected, tableConfig);
    }

    this.processing = true;
    this.httpService.getTaxReportByItem(tableConfig).then((data: any) => {
      this.finalData = this.formatService.formatTaxByItemList(data);
      if (!this.isPassThroughTaxEnable) this.finalData = this.finalData.filter((element) => element.type !== 'passThroughTax');
      this.processing = false;
    });
  }

  downloadRoyaltyReport(filter: any) {
    let tableConfig: any = {};
    const { isMultiLocationEnabled, isRevenueRecognitionSettleEnabled } = this.helperService.getCompany();
    const { shopIds = [], date = {} } = filter;
    this.setDataService();

    // Don't make call if date is missing
    if (!date.startDate || !date.endDate) return;

    if (isMultiLocationEnabled && (!shopIds || (shopIds && !shopIds.length))) return;

    if (shopIds.length > 0) {
      tableConfig.shopIds = shopIds;
    } else {
      tableConfig.shopIds = [];
    }

    if (date.startDate && date.endDate) {
      tableConfig.startDate = date.startDate;
      tableConfig.endDate = date.endDate;
    }

    if (this.dataService.finalizeFilterBy && isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoiceDate';
    }

    this.processing = true;
    this.httpService.getRoyaltyFeeSalesBreakDown(tableConfig).then((data: any) => {
      this.finalData = this.formatService.formatRoyaltyReport(data.groups[0]?.records, data?.groups[0]?.extras);
      // if (!this.isPassThroughTaxEnable) this.finalData = this.finalData.filter(element => element.type !== 'passThroughTax');
      this.processing = false;
    });
  }

  downloadSupplierDetailsReport(filter: any) {
    const tableConfig: any = this.formatService.formatSupplierDrilldownFilter(filter);
    tableConfig.searchQuery = this.dataService.itemName;

    this.processing = true;
    tableConfig._id = this.dataService.supplierId;
    this.httpService.getSupplierReportSummaryById(tableConfig).then(
      (data: any) => {
        this.finalData = this.formatService.formatSupplierDetailsList(data[0].records);
        if (data[0].extras[0]) {
          const { totalCost, totalTax, totalPurchaseValue, totalNumberOfItemsPurchased, totalVolumePurchased } = data[0].extras[0];
          let obj = {
            cost: totalCost,
            quantity: totalVolumePurchased,
            taxedAmount: totalTax,
            subTotal: totalPurchaseValue,
          };
          this.finalData = [obj].concat(this.finalData);
        }
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  async downloadSupplierDetailsSummaryReport(filter: any) {
    const tableConfig: any = this.formatService.formatSupplierDrilldownFilter(filter);
    this.shopsMap = this.dataService.shopsMap;
    tableConfig.searchQuery = this.dataService.itemName;
    let csvData = [];
    this.processing = true;
    // tableConfig.page = this.dataService.supplierPageSizes.itemPurchase.page;
    tableConfig.sortField = this.dataService.supplierPageSizes.itemPurchase.sort;
    tableConfig.sortOrder = this.dataService.supplierPageSizes.itemPurchase.order;
    // tableConfig.limit = 8;
    tableConfig._id = this.dataService.supplierId;
    const itemsPurchased = await this.httpService.getSupplierReportItemsPurchasedById(tableConfig);
    if (itemsPurchased && itemsPurchased[0].records) {
      itemsPurchased[0].records.map((record) => (record.activityType = 'Items purchased'));
      csvData = this.formatService.formatExportSupplierSummaryList(itemsPurchased[0].records);
    }
    tableConfig.itemType = 'core';
    // tableConfig.page = this.dataService.supplierPageSizes.core.page;
    tableConfig.sortField = this.dataService.supplierPageSizes.core.sort;
    tableConfig.sortOrder = this.dataService.supplierPageSizes.core.order;
    // tableConfig.limit = 4;
    const coreReturned = await this.httpService.getSupplierCors(tableConfig);
    if (coreReturned && coreReturned.records.length > 0) {
      coreReturned.records.map((record) => (record.activityType = 'Core returned'));
      csvData = [...csvData, ...this.formatService.formatExportSupplierSummaryList(coreReturned.records)];
    }

    tableConfig.itemType = 'item';
    // tableConfig.page = this.dataService.supplierPageSizes.itemReturn.page;
    tableConfig.sortField = this.dataService.supplierPageSizes.itemReturn.sort;
    tableConfig.sortOrder = this.dataService.supplierPageSizes.itemReturn.order;
    // tableConfig.limit = 4;
    const itemsReturned = await this.httpService.getSupplierCors(tableConfig);
    if (itemsReturned && itemsReturned.records.length > 0) {
      itemsReturned.records.map((record) => (record.activityType = 'Items returned'));
      csvData = [...csvData, ...this.formatService.formatExportSupplierSummaryList(itemsReturned.records)];
    }

    const itemPurchaseStats = (itemsPurchased && itemsPurchased[0] && itemsPurchased[0].extras[0]) || {};
    const itemsReturnedStats = (itemsReturned && itemsReturned.extras[0]) || {};
    const coreReturnedStats = (coreReturned && coreReturned.extras[0]) || {};

    let obj = {
      cost: (itemPurchaseStats.totalCost || 0) + (itemsReturnedStats.totalCost || 0) + (coreReturnedStats.totalCost || 0),
      quantity: (itemPurchaseStats.totalQuantity || 0) + (itemsReturnedStats.totalQuantity || 0) + (coreReturnedStats.totalQuantity || 0),
      taxedAmount: (itemPurchaseStats.totalTax || 0) + (itemsReturnedStats.totalTax || 0) + (coreReturnedStats.totalTax || 0),
      subTotal: (itemPurchaseStats.subTotal || 0) + (itemsReturnedStats.subTotal || 0) + (coreReturnedStats.subTotal || 0),
    };

    this.finalData = csvData;
    this.finalData = [obj].concat(this.finalData);
    this.finalData.map((record) => (record.location = this.shopsMap[record.location]?.shopName));
    this.processing = false;
  }

  downloadSupplierReport(filter: any) {
    const tableConfig: any = this.formatService.formatSupplierFilter(filter);
    tableConfig.searchQuery = this.dataService.itemName;
    this.processing = true;

    if (this.isSupplierReportEnabled) {
      this.httpService.getSupplierReportSummaryList(tableConfig).then(
        (data: any) => {
          this.finalData = this.formatService.formatSupplierReportSummaryList(data[0].records);
          if (data[0].extras[0]) {
            const { itemValue, itemCore, itemReturn, netValue } = data[0].extras[0];
            let obj = {
              totalNumberOfCoreReturned: itemCore,
              totalNumberOfItemsReturned: itemReturn,
              totalNumberOfItemsPurchased: itemValue,
              totalNetPurchaseValue: netValue,
            };

            this.finalData = [obj].concat(this.finalData);
          }
          this.processing = false;
        },
        (error) => {
          this.processing = false;
          this.helperService.showToaster('error', error);
        },
      );
    } else {
      this.httpService.getSupplierReportSummary(tableConfig).then(
        (data: any) => {
          this.finalData = this.formatService.formatSupplierReportList(data[0].records);
          if (data[0].extras[0]) {
            const { totalNumberOfItemsPurchased, totalVolumePurchased, totalPurchaseValue } = data[0].extras[0];
            let obj = {
              totalNumberOfItemsPurchased: totalNumberOfItemsPurchased,
              totalVolumePurchased: totalVolumePurchased,
              totalPurchaseValue: totalPurchaseValue,
            };
            this.finalData = [obj].concat(this.finalData);
          }
          this.processing = false;
        },
        (error) => {
          this.processing = false;
          this.helperService.showToaster('error', error);
        },
      );
    }
  }

  async downloadCommissionDrillDownReport(filter: any) {
    const userId = this.activatedRoute.snapshot.params['id'];
    const tableConfig: any = {
      startDate: filter.date.startDate,
      endDate: filter.date.endDate,
      sortField: 'code',
      sortOrder: 1,
      employeeId: userId,
      searchQuery: this.searchQuery,
    };
    this.processing = true;
    try {
      const [[commissionDetails], totalCommission]: any = await Promise.all([
        this.httpService.getCommissionDrillDown({ ...tableConfig }),
        this.httpService.getEmployeeTotalCommission({ ...tableConfig }),
      ]);
      if (commissionDetails) {
        const { records = [] } = commissionDetails;
        this.finalData = this.formatService.formatCommissionDrillDownReport(records, true);
      }
      const totalCommissionEarned: any = (totalCommission && totalCommission.commissionEarned) || 0;
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.processing = false;
    }
  }

  async downloadUnusedItemReport(filter: any) {
    const tableConfig: any = {
      sortField: 'partName',
      sortOrder: 1,
      ...this.formatService.formatUnusedPartFilter(filter),
    };
    tableConfig.searchQuery = this.helperService.encodeURIComponent(this.dataService.itemName);
    this.processing = true;
    try {
      const data = await this.httpService.getOrderUnusedItem(tableConfig);

      this.finalData = this.formatService.formatUnusedPartReport(data.records || []);
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.processing = false;
    }
  }

  downloadCommissionReport(filter: any) {
    const tableConfig: any = {
      startDate: filter.date.startDate,
      endDate: filter.date.endDate,
      sortField: 'name',
      sortOrder: 1,
    };
    this.processing = true;
    this.httpService.getCommissionSummary(tableConfig).then(
      (res: any) => {
        this.processing = false;
        if (res && res.length > 0) {
          const { records = [] } = res[0];
          this.finalData = this.formatService.formatCommissionReportList(records, true);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
        this.processing = false;
      },
    );
  }

  downloadItemSoldReport(filter) {
    const { date = {}, itemType = {}, itemCategory = { selected: [] }, itemPaymentStatus = {}, serviceWriter = {} } = filter;
    const tableConfig: any = {};

    const { startDate, endDate } = date;
    if (startDate && endDate) {
      tableConfig.startDate = startDate;
      tableConfig.endDate = endDate;

      if (filter.shopIds?.length > 0) {
        tableConfig.shopIds = filter.shopIds;
      } else {
        tableConfig.shopIds = [];
      }

      if (serviceWriter) {
        tableConfig.serviceWriter = serviceWriter.id;
      } else {
        tableConfig.serviceWriter = null;
      }

      if (itemCategory && itemCategory.selected && itemCategory.selected.length) {
        tableConfig.itemCategory = itemCategory.selected.map(({ name }) => name);
      } else {
        tableConfig.itemCategory = null;
      }
      // if ((itemType.tire && itemType.part) || (!itemType.tire && !itemType.part)) {
      //   tableConfig.itemType = 'all';
      // } else {
      //   if (itemType.tire) tableConfig.itemType = 'tire';
      //   if (itemType.part) tableConfig.itemType = 'part';
      // }
      // if ((itemType.tireStorage && itemType.part) || (!itemType.tireStorage && !itemType.part)) {
      //   tableConfig.itemType = 'all';
      // } else {
      //   if (itemType.tireStorage) tableConfig.itemType = 'tireStorage';
      //   if (itemType.part) tableConfig.itemType = 'part';
      // }
      if (itemPaymentStatus) {
        const { isChecked = false } = itemPaymentStatus;
        tableConfig.isPaidFull = isChecked;
      } else {
        tableConfig.isPaidFull = false;
      }

      if (this.isRevenueRecognitionSettleEnabled) {
        tableConfig.dateType = 'finalizeDate';
      } else {
        tableConfig.dateType = 'invoiceDate';
      }

      if ((itemType.tire && itemType.part) || (!itemType.tire && !itemType.part)) {
        tableConfig.itemType = 'all';
      } else {
        if (itemType.tire) tableConfig.itemType = 'tire';
        if (itemType.part) tableConfig.itemType = 'part';
      }

      if (this.filter?.genericFilter && this.filter?.genericFilter?.selected?.length) {
        this.setFinalizeTypeFilter(this.filter.genericFilter.selected, tableConfig);
      }
    }
    tableConfig.searchQuery = this.dataService.itemName;
    this.processing = true;
    this.httpService.getItemSoldReport(tableConfig).then(
      (data: any) => {
        this.finalData = this.formatService.formatItemsSoldReportList(data[0].records);
        if (data[0].extras[0]) {
          const { avgprofatibilty, totalSalesValue, totalVolumePurchased, profitability, totalCostValue, salesValue } = data[0].extras[0];
          let obj = {
            avgprofatibilty: avgprofatibilty.toFixed(2),
            totalSalesValue: totalSalesValue,
            salesVolume: totalVolumePurchased,
            profitability: profitability,
            totalCostValue: totalCostValue,
            salesValue: salesValue,
          };
          this.finalData = [obj].concat(this.finalData);
        }
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  // Item sold Report Enhancement
  downloadItemSoldReportEnhancement(filter) {
    const {
      date = {},
      itemType = {},
      itemCategory = { selected: [] },
      itemPaymentStatus = {},
      paymentStatus = {},
      serviceWriter = {},
      exportHybrid = false,
      itemTypeDrillDown = [],
      salesCode = {},
      salesGroup = {},
    } = filter;
    const tableConfig: any = {};

    const { startDate, endDate } = date;

    if (filter.tech && filter.tech.id) {
      tableConfig.tech = filter.tech.id;
    } else {
      tableConfig.tech = null;
    }

    if (salesCode) {
      tableConfig.salesCode = this.helperService.encodeURIComponent(salesCode?.title);
    } else {
      tableConfig.salesCode = null;
    }
    if (salesGroup) {
      tableConfig.salesGroup = this.helperService.encodeURIComponent(salesGroup?.name);
    } else {
      tableConfig.salesGroup = null;
    }

    if (startDate && endDate) {
      tableConfig.startDate = startDate;
      tableConfig.endDate = endDate;

      if (filter.shopIds?.length > 0) {
        tableConfig.shopIds = filter.shopIds;
      } else {
        tableConfig.shopIds = [];
      }

      if (serviceWriter) {
        tableConfig.serviceWriter = serviceWriter.id;
      } else {
        tableConfig.serviceWriter = null;
      }

      if (itemCategory && itemCategory.selected && itemCategory.selected.length) {
        tableConfig.itemCategory = itemCategory.selected.map(({ name }) => name);
      } else {
        tableConfig.itemCategory = null;
      }

      if (paymentStatus && paymentStatus.id) {
        tableConfig.paymentStatus = paymentStatus.id;
      } else {
        tableConfig.paymentStatus = null;
      }

      if (itemPaymentStatus) {
        const { isChecked = false } = itemPaymentStatus;
        tableConfig.isPaidFull = isChecked;
      } else {
        tableConfig.isPaidFull = false;
      }

      if (this.isRevenueRecognitionSettleEnabled) {
        tableConfig.dateType = 'finalizeDate';
      } else {
        tableConfig.dateType = 'invoiceDate';
      }

      // if ((itemType.tire && itemType.part) || (!itemType.tire && !itemType.part)) {
      //   tableConfig.itemType = 'all';
      // } else {
      //   if (itemType.tire) tableConfig.itemType = 'tire';
      //   if (itemType.part) tableConfig.itemType = 'part';
      // }

      if (!this.isDrillDown) {
        if (
          (itemType.tire && itemType.part && itemType.labor && itemType.sublet && itemType.other && itemType.tireStorage) ||
          (!itemType.tire && !itemType.part && !itemType.labor && !itemType.sublet && !itemType.other && !itemType.tireStorage)
        ) {
          tableConfig.itemType = 'all';
        } else {
          tableConfig.itemType = {
            tire: itemType.tire || false,
            part: itemType.part || false,
            labor: itemType.labor || false,
            sublet: itemType.sublet || false,
            other: itemType.other || false,
            tireStorage: itemType.tireStorage || false,
          };

          tableConfig.itemType = Object.keys(itemType)
            .filter((key) => itemType[key] === true)
            .reduce((acc, key) => {
              acc[key] = true;
              return acc;
            }, {});
          tableConfig.itemType = JSON.stringify(tableConfig.itemType).replace(/"/g, '');
        }
      }

      // Drill down
      if (itemTypeDrillDown && this.isDrillDown) {
        tableConfig.itemType = {};
        tableConfig.itemType[itemTypeDrillDown] = true;
        tableConfig.itemType = JSON.stringify(tableConfig.itemType).replace(/"/g, '');
      }

      if (exportHybrid) {
        tableConfig.exportHybrid = exportHybrid;
      } else {
        tableConfig.exportHybrid = false;
      }

      if (this.filter?.genericFilter && this.filter?.genericFilter?.selected?.length) {
        this.setFinalizeTypeFilter(this.filter.genericFilter.selected, tableConfig);
      }
    }
    tableConfig.searchQuery = this.dataService.itemName;
    if (this.filterState.isPrint) {
      this.paramFilters = this.helperService.deepCopy(tableConfig);
      this.paramFilters.tableConfigItemSold = JSON.stringify(this.dataService.tableConfigItemSold);
      this.paramFilters.reportType = this.filterState.id;
    }
    this.processing = true;
    this.httpService.getItemSoldReport(tableConfig).then(
      (data: any) => {
        this.finalData = this.formatService.formatItemsSoldReportList(data[0].records, this.isDrillDown);
        if (!this.isDrillDown) {
          if (data[0]?.extras[0]) {
          const { salesValue, averageCost, avgprofatibilty, totalSalesValue, totalVolumePurchased, profitability, totalCostValue, totalPricePerUnitValue, updatedprofitability } = data[0]?.extras[0];
          let obj = {
            avgprofatibilty: avgprofatibilty ? (avgprofatibilty * 100).toFixed(2) + ' %' : '0.00 %',
            profitability: profitability ? profitability.toFixed(2) : '0.00',
            updatedprofitability: updatedprofitability ? updatedprofitability.toFixed(2) : '0.00',
            salesVolume: totalVolumePurchased ? totalVolumePurchased.toFixed(2) : '0.00',
            totalCostValue: totalCostValue ? totalCostValue.toFixed(2) : '0.00',
            totalSalesValue: totalSalesValue ? totalSalesValue.toFixed(2) : '0.00',
            averageCost: averageCost ? averageCost.toFixed(2) : '0.00',
            salesValue: totalPricePerUnitValue ? totalPricePerUnitValue.toFixed(2) : '0.00',
          };
          this.finalData = [obj].concat(this.finalData);
        }
      }
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  // fee item report
  downloadFeeItemReport(filters: any) {
    const tableConfig: any = { itemId: this.data.itemId, feeType: this.data.type };
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    const { shopIds = [], date = {}, feeType = {}, paidStatus = {} } = filters;

    // Don't make call if date is missing
    if (!date.startDate || !date.endDate) return;
    if (isMultiLocationEnabled && (!shopIds || (shopIds && !shopIds.length))) return;

    if (shopIds.length > 0) {
      tableConfig.shopIds = shopIds;
    } else {
      tableConfig.shopIds = [];
    }

    if (date.startDate && date.endDate) {
      tableConfig.invoiceDateStart = date.startDate;
      tableConfig.invoiceDateEnd = date.endDate;
    }

    if (feeType.roLevel !== feeType.serviceLevel) {
      tableConfig.feeType = feeType.roLevel ? 'order' : 'service';
    }

    if (paidStatus) {
      const { paid = false, partiallyPaid = false, unPaid = false } = paidStatus;

      if (Array.from(new Set([paid, partiallyPaid, unPaid])).length > 1) {
        tableConfig.paidStatus = { paid, partiallyPaid, unPaid };
      }
    }

    if (this.isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoiceDate';
    }

    if (this.filter?.genericFilter && this.filter?.genericFilter?.selected?.length) {
      this.setFinalizeTypeFilter(this.filter.genericFilter.selected, tableConfig);
    }

    tableConfig.search = this.dataService.itemName;

    this.processing = true;
    this.httpService
      .getFeeItemsReportSummaryById(tableConfig)
      .then(
        (data: any) => {
          this.finalData = this.formatService.formatFeeByIdReportList(data.records);
          if (isMultiLocationEnabled) {
            this.mapMultilocationShop();
          }
        },
        (error) => {
          this.helperService.showToaster('error', error);
        },
      )
      .finally(() => {
        this.processing = false;
      });
  }

  downloadDiscountItemReport(filters: any) {
    let tableConfig: any = { itemId: this.data.itemId, discountOn: this.activatedRoute.snapshot.params['type'] };
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    const { shopIds = [], date = {} } = filters;

    // Don't make call if date is missing
    if (!date.startDate || !date.endDate) return;
    if (isMultiLocationEnabled && (!shopIds || (shopIds && !shopIds.length))) return;

    tableConfig = { ...tableConfig, ...this.formatService.formatDiscountDrillDownReportFilter(filters) };

    if (this.isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoiceDate';
    }

    this.processing = true;
    this.httpService
      .getDiscountsReportSummaryById(tableConfig)
      .then(
        (data: any) => {
          this.finalData = this.formatService.formatDiscountByIdReportList(data.records);
          this.mapMultilocationShop();
        },
        (error) => {
          this.helperService.showToaster('error', error);
        },
      )
      .finally(() => {
        this.processing = false;
      });
  }

  //discount summary report
  downloadDiscountSummaryReport(filters: any) {
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    const { shopIds = [], date = {} } = filters;
    let tableConfig: any = { search: this.dataService.itemName };

    // Don't make call if date is missing
    if (!date.startDate || !date.endDate) return;
    if (isMultiLocationEnabled && (!shopIds || (shopIds && !shopIds.length))) return;

    tableConfig = { ...tableConfig, ...this.formatService.formatDiscountReportFilter(filters) };

    if (filters?.genericFilter && filters?.genericFilter?.selected?.length) {
      this.setFinalizeTypeFilter(filters.genericFilter.selected, tableConfig);
    }

    if (this.isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoiceDate';
    }

    this.processing = true;
    this.httpService
      .getAllDiscountsReport(tableConfig)
      .then(
        (data: any) => {
          this.finalData = this.formatService.formatDiscountReportList(data.records);
          if (data.stats) {
            const { noOfTimesUsed, avgPrice, price } = data.stats;
            let obj = {
              addedToRO: noOfTimesUsed,
              averageDiscount: this.calculationService.roundOff(avgPrice),
            };
            this.finalData = [obj].concat(this.finalData);
          }
        },
        (error) => {
          this.helperService.showToaster('error', error);
        },
      )
      .finally(() => {
        this.processing = false;
      });
  }

  // fee summary report
  downloadFeeSummaryReport(filters: any) {
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    const { shopIds = [], date = {}, feeType = {}, paidStatus = {} } = filters;
    const tableConfig: any = {};
    tableConfig.feeType = [];

    // Don't make call if date is missing
    if (!date.startDate || !date.endDate) return;
    if (isMultiLocationEnabled && (!shopIds || (shopIds && !shopIds.length))) return;

    if (shopIds.length > 0) {
      tableConfig.shopIds = shopIds;
    } else {
      tableConfig.shopIds = [];
    }

    if (date.startDate && date.endDate) {
      tableConfig.invoiceDateStart = date.startDate;
      tableConfig.invoiceDateEnd = date.endDate;
    }

    // if (feeType.roLevel !== feeType.serviceLevel) {
    //   tableConfig.feeType = feeType.roLevel ? 'order' : 'service';
    // }

    if (feeType.roLevel || feeType.serviceLevel || feeType.passThroughTax) {
      if (feeType.roLevel) tableConfig.feeType.push('order');
      if (feeType.serviceLevel) tableConfig.feeType.push('service');
      if (feeType.passThroughTax) tableConfig.feeType.push('passThroughTax');
    }

    if (paidStatus) {
      const { paid = false, partiallyPaid = false, unPaid = false } = paidStatus;

      if (Array.from(new Set([paid, partiallyPaid, unPaid])).length > 1) {
        tableConfig.paidStatus = { paid, partiallyPaid, unPaid };
      }
    }

    if (this.isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoiceDate';
    }

    if (this.filter?.genericFilter && this.filter?.genericFilter?.selected?.length) {
      this.setFinalizeTypeFilter(this.filter.genericFilter.selected, tableConfig);
    }

    tableConfig.search = this.dataService.itemName;
    this.processing = true;
    this.httpService
      .getFeeSummaryReport(tableConfig)
      .then(
        (data: any) => {
          this.finalData = this.formatService.formatFeeReportList(data.records);
          if (!this.isPassThroughTaxEnable) this.finalData = this.finalData.filter((element) => element.type !== 'passThroughTax');
          const { avgFeeCost, avgFeePrice, timeSold, profitability, price, cost, qtySold } = data.stats;
          let obj = {
            cost: this.currencyPipe.transform(avgFeeCost || 0, currency.USD),
            price: this.currencyPipe.transform(avgFeePrice || 0, currency.USD),
            // profitability: `${profitability}%`,
            profitability: `${this.calculationService.roundOffToDecimalPlaces(profitability)}%`,
            timeSold: timeSold,
            qtySold: qtySold,
            totalCost: this.currencyPipe.transform(cost || 0, currency.USD),
            totalPrice: this.currencyPipe.transform(price || 0, currency.USD),
          };
          this.finalData = [obj].concat(this.finalData);
        },
        (error) => {
          this.helperService.showToaster('error', error);
        },
      )
      .finally(() => {
        this.processing = false;
      });
  }

  downloadSalesReport(filter) {
    const tableConfig: any = {};
    const { isMultiLocationEnabled } = this.helperService.getCompany();

    if (this.processing) {
      return;
    }

    if (filter.tech && filter.tech.id) {
      tableConfig.tech = filter.tech.id;
    } else {
      tableConfig.tech = null;
    }

    if (filter.tags.selected.length > 0) {
      tableConfig.tags = filter.tags.selected.map(({ name }) => name);
    } else {
      tableConfig.tags = [];
    }

    if (filter.serviceWriter && filter.serviceWriter.id) {
      tableConfig.serviceWriter = filter.serviceWriter.id;
    } else {
      tableConfig.serviceWriter = null;
    }

    if (filter.customerFleet) {
      if ((filter.customerFleet.regular && filter.customerFleet.fleet) || (!filter.customerFleet.regular && !filter.customerFleet.fleet)) {
        tableConfig.isFleetCustomer = null;
      } else {
        tableConfig.isFleetCustomer = filter.customerFleet.fleet;
      }
    }

    if (filter.companyName && filter.companyName.selected && filter.companyName.selected.length) {
      tableConfig.companyName = filter.companyName.selected.map(({ name }) => name);
    } else {
      tableConfig.companyName = [];
    }

    if (filter.customerType.newCustomers && filter.customerType.repeatCustomers) {
      tableConfig.customerType = 'all';
    } else if (filter.customerType.newCustomers) {
      tableConfig.customerType = 'new';
    } else if (filter.customerType.repeatCustomers) {
      tableConfig.customerType = 'old';
    } else {
      tableConfig.customerType = 'all';
    }

    if (filter.date.startDate && filter.date.endDate) {
      tableConfig.startDate = filter.date.startDate;
      tableConfig.endDate = filter.date.endDate;
    }

    if (this.isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
      tableConfig.sort = 'finalizeDate';
      tableConfig.sortField = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoiceDate';
      tableConfig.sort = 'invoiceDate';
      tableConfig.sortField = 'invoiceDate';
    }

    if (this.dataService.tableConfigSalesTrend && this.dataService.tableConfigSalesTrend?.sortField) {
      tableConfig.sortField = this.dataService.tableConfigSalesTrend?.sortField;
    }

    if (this.dataService.tableConfigSalesTrend && this.dataService.tableConfigSalesTrend?.sortOrder) {
      tableConfig.sortField = this.dataService.tableConfigSalesTrend?.sortField;
    }

    if (this.filter?.genericFilter && this.filter?.genericFilter?.selected?.length) {
      this.setFinalizeTypeFilter(this.filter.genericFilter.selected, tableConfig);
    }

    if (filter.payment) {
      // tableConfig.paid = filter.payment.paid;
      // tableConfig.partiallyPaid = filter.payment.partiallyPaid;
      // tableConfig.unpaid = filter.payment.unpaid;
      tableConfig.isPaidFull = filter.payment.paid;
      tableConfig.isUnpaid = filter.payment.unpaid;
      tableConfig.isPaidPartial = filter.payment.partiallyPaid;
    }

    if (isMultiLocationEnabled && filter.shopIds && filter.shopIds.length > 0) {
      tableConfig.shopIds = filter.shopIds;
    } else {
      tableConfig.shopIds = [];
    }
    tableConfig.order = -1;
    if (this.filterState.isPrint) {
      this.paramFilters = this.helperService.deepCopy(tableConfig);
      this.paramFilters.tableConfigSalesTrend = JSON.stringify(this.dataService.tableConfigSalesTrend);
      this.paramFilters.reportType = this.filterState.id;
      if (filter.customerFleet) {
        if (filter.customerFleet.regular && filter.customerFleet.fleet) {
          this.paramFilters.isFleetCustomer = 'all';
        }
      }
      if (filter.customerType.newCustomers && filter.customerType.repeatCustomers) {
        this.paramFilters.customerType = 'all';
      } else if (!filter.customerType.newCustomers && !filter.customerType.repeatCustomers) {
        this.paramFilters.customerType = '';
      }
    }
    this.processing = true;
    this.httpService
      .getReportSalesTrendList(tableConfig)
      .then(
        (data: any) => {
          this.finalData = this.formatService.formatSalesTrendReportExport(data.records);
          if (isMultiLocationEnabled) {
            this.shopsMap = this.dataService.shopsMap;
            for (let i = 0; i < this.finalData.length; i++) {
              this.finalData[i].shopId = this.shopsMap[this.finalData[i].shopId]?.shopName;
            }
          }
          if (data.extras) {
            let obj = { 'Order amount': data.extras.totalOrderAmt };
            this.finalData = [obj].concat(this.finalData);
          }
        },
        (error) => {
          this.helperService.showToaster('error', error);
        },
      )
      .finally(() => {
        this.processing = false;
      });
  }

  downloadItemSoldDetailsReport(filter) {
    const tableConfig: any = {};
    const { isMultiLocationEnabled } = this.helperService.getCompany();

    if (this.processing) {
      return;
    }

    // if (this.isFilterByFinalizeDate) {
    if (filter.genericFilter?.selected?.length) {
      this.formatService.formatRevenueRecognitionAppliedFilter(filter.genericFilter.selected, tableConfig);
    } else {
      tableConfig.finalizeType = [];
      tableConfig.thirdPartyAccount = [];
    }
    // }

    if (filter.serviceWriter && filter.serviceWriter?.id) {
      tableConfig.serviceWriter = filter.serviceWriter.id;
    } else {
      tableConfig.serviceWriter = null;
    }

    if (filter.tech && filter.tech.id) {
      tableConfig.tech = filter.tech.id;
    } else {
      tableConfig.tech = null;
    }

    if (filter.paymentStatus && filter.paymentStatus.id) {
      tableConfig.paymentStatus = filter.paymentStatus.id;
    } else {
      tableConfig.paymentStatus = null;
    }

    if (filter.date.startDate && filter.date.endDate) {
      tableConfig.startDate = filter.date.startDate;
      tableConfig.endDate = filter.date.endDate;

      if (filter.supplier && filter.supplier.selected && filter.supplier.selected.length) {
        tableConfig.supplier = filter.supplier.selected.map(({ name }) => name);
      } else {
        tableConfig.supplier = [];
      }
    }

    // if (this.isRevenueRecognitionSettleEnabled) {
    //   tableConfig.dateType = 'finalizeDate';
    //   tableConfig.sort = 'finalizeDate';
    //   tableConfig.sortField = 'finalizeDate';
    // } else {
    //   tableConfig.dateType = 'invoiceDate';
    //   tableConfig.sort = 'invoiceDate';
    //   tableConfig.sortField = 'invoiceDate';
    // }

    if (filter?.salesCode) {
      tableConfig.salesCode = this.helperService.encodeURIComponent(filter?.salesCode.title);
    } else {
      tableConfig.salesCode = null;
    }

    if (filter?.salesGroup) {
      tableConfig.salesGroup = this.helperService.encodeURIComponent(filter?.salesGroup.name);
    } else {
      tableConfig.salesGroup = null;
    }

    if (filter.payment) {
      tableConfig.isPaidFull = filter.payment.paid;
      tableConfig.isUnpaid = filter.payment.unpaid;
      tableConfig.isPaidPartial = filter.payment.partiallyPaid;
    }

    tableConfig.order = -1;
    if (this.filterState.isPrint) {
      this.paramFilters = this.helperService.deepCopy(tableConfig);
      this.paramFilters.tableConfigItemSold = JSON.stringify(this.dataService.tableConfigItemSold);
      this.paramFilters.reportType = this.filterState.id;
    }
    this.processing = true;
    const _id = this.activatedRoute?.snapshot.params['id'];
    tableConfig._id = _id;
    tableConfig.dateType = filter?.dateType
    this.httpService
      .getItemsReportSummaryById(tableConfig)
      .then(
        (data: any) => {
          const { records, extras } = data[0];
          this.finalData = this.formatService.formatItemsRecordsList(records);

          // if (data.extras) {
          //   let obj = { 'Order amount': data.extras.totalOrderAmt };
          //   this.finalData = [obj].concat(this.finalData);
          // }
        },
        (error) => {
          this.helperService.showToaster('error', error);
        },
      )
      .finally(() => {
        this.processing = false;
      });
  }

  setMultiTechColumn() {
    this.allColumns.technicianActivity = [...this.allColumns.technicianActivity, { name: 'Role', value: 'Role', isChecked: true }];
    // this.allColumns.technicianSummary = [...this.allColumns.technicianSummary, { name: 'Role', value: 'Role', isChecked: true }];
    this.allColumns.techDetail = [...this.allColumns.techDetail, { name: 'Role', value: 'Role', isChecked: true }];
  }

  setSplitBillTechColumn() {
    if (!this.dataService.isSplitTechActuallBillableHrs) return;
    this.isSplitTechActuallBillableHrs = this.dataService.isSplitTechActuallBillableHrs;
    this.allColumns.techDetail = [
      ...this.allColumns.techDetail,
      { value: 'plannedHours', name: 'Techs estimated hrs', isChecked: true },
      { value: 'billedHours', name: 'Techs billable hrs', isChecked: true },
    ];
  }

  checkTechDrilldownReport(filter) {
    const query: any = {};
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    if (isMultiLocationEnabled && filter.shopIds && filter.shopIds.length > 0) {
      query.shopIds = filter.shopIds;
    } else {
      query.shopIds = '';
    }

    if (filter.date.startDate && filter.date.endDate) {
      query.startDate = filter.date.startDate;
      query.endDate = filter.date.endDate;
      query.serviceCompleteDate = this.dataService.serviceCompleteDate;

      if (filter.tech && filter.tech.id) {
        query.techs = filter.tech.id;
      }
    }
    this.processing = true;
    this.httpService
      .getTechnicianDrillDown(query, {})
      .then(
        (results: any) => {
          this.finalData.length = results.metaData.totalRecords;
        },
        (error) => {
          this.helperService.showToaster('error', error);
        },
      )
      .finally(() => (this.processing = false));
  }

  downloadProfitabilityReport(filter) {
    const tableConfig: any = { sortField: 'title', sortOrder: 1 };
    const { isMultiLocationEnabled } = this.helperService.getCompany();

    if (this.processing) {
      return;
    }
    tableConfig.profitabilityUseWorkedHours = filter.profitabilityUseWorkedHours;
    tableConfig.tag = [];
    if (filter.tags && filter.tags.selected && filter.tags.selected.length > 0) {
      tableConfig.tag = filter.tags.selected.map((tag) => tag.name);
    }

    if (filter.serviceWriter && filter.serviceWriter.id) {
      tableConfig.serviceWriter = filter.serviceWriter.id;
    } else {
      tableConfig.serviceWriter = null;
    }

    if (filter.customerType.newCustomers && filter.customerType.repeatCustomers) {
      tableConfig.customerType = 'all';
    } else if (filter.customerType.newCustomers) {
      tableConfig.customerType = 'new';
    } else if (filter.customerType.repeatCustomers) {
      tableConfig.customerType = 'old';
    } else {
      tableConfig.customerType = 'all';
    }

    if (filter.customerFleet) {
      if ((filter.customerFleet.regular && filter.customerFleet.fleet) || (!filter.customerFleet.regular && !filter.customerFleet.fleet)) {
        tableConfig.isFleetCustomer = null;
      } else {
        tableConfig.isFleetCustomer = filter.customerFleet.fleet;
      }
    }

    if (this.isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoicedDate';
    }

    if (filter.companyName && filter.companyName.selected && filter.companyName.selected.length) {
      tableConfig.companyName = filter.companyName.selected.map(({ name }) => name);
    } else {
      tableConfig.companyName = [];
    }

    if (filter.date.startDate && filter.date.endDate) {
      tableConfig.startDate = filter.date.startDate;
      tableConfig.endDate = filter.date.endDate;
    }

    if (filter.date.startDate && filter.date.endDate) {
      tableConfig.startDate = filter.date.startDate;
      tableConfig.endDate = filter.date.endDate;
    }

    if (filter.payment) {
      tableConfig.isPaidFull = filter.payment.paid;
      tableConfig.isUnpaid = filter.payment.unpaid;
      tableConfig.isPaidPartial = filter.payment.partiallyPaid;
    }

    if (isMultiLocationEnabled && filter.shopIds && filter.shopIds.length > 0) {
      tableConfig.shopIds = filter.shopIds;
    } else {
      tableConfig.shopIds = '';
    }

    if (filter.payment) {
      tableConfig.isPaidFull = filter.payment.paid;
      tableConfig.isUnpaid = filter.payment.unpaid;
      tableConfig.isPaidPartial = filter.payment.partiallyPaid;
    }
    if (this.filter?.genericFilter && this.filter?.genericFilter?.selected?.length) {
      this.setFinalizeTypeFilter(this.filter.genericFilter.selected, tableConfig);
    }

    this.processing = true;
    this.httpService
      .getProfitabilityList(tableConfig)
      .then(
        (response: any) => {
          this.httpService
            .getProfitabilityStats(tableConfig)
            .then(
              (data: any) => {
                if (data.queryMargin) {
                  const {
                    totalPrice,
                    totalCost,
                    totalDiscount,
                    totalProfit,
                    totalProfitPercentage,
                    partPrice,
                    partCost,
                    partProfit,
                    partProfitPercentage,
                    laborPrice,
                    laborCost,
                    laborProfit,
                    laborProfitPercentage,
                    tirePrice,
                    tireCost,
                    tireProfit,
                    tireProfitPercentage,
                    subletPrice,
                    subletCost,
                    subletProfit,
                    subletProfitPercentage,
                    tireStoragePrice,
                    tireStorageCost,
                    tireStorageProfit,
                    tireStorageProfitPercentage,
                    otherPrice,
                    otherCost,
                    otherProfit,
                    otherProfitPercentage,
                    hazmatFeePrice,
                    hazmatFeeCost,
                    hazmatFeeProfit,
                    hazmatFeeProfitPercentage,
                  } = data.queryMargin;

                  this.finalData = this.formatService.formatProfitabilityReportExport(response.records);
                  if (isMultiLocationEnabled) {
                    this.shopsMap = this.dataService.shopsMap;
                    for (let i = 0; i < this.finalData.length; i++) {
                      this.finalData[i].shopId = this.shopsMap[this.finalData[i].shopId]?.shopName;
                    }
                  }
                  let obj = {
                    'RO Price': totalPrice,
                    'RO Cost': totalCost,
                    // 'Order Discount' : totalDiscount,
                    'RO Margin': `${totalProfitPercentage}%`,

                    'Part Price': partPrice,
                    'Part Cost': partCost,
                    'Part Margin': `${partProfitPercentage}%`,

                    'Labor Price': laborPrice,
                    'Labor Cost': laborCost,
                    'Labor Margin': `${laborProfitPercentage}%`,

                    'Tire Price': tirePrice,
                    'Tire Cost': tireCost,
                    'Tire Margin': `${tireProfitPercentage}%`,

                    'Tire Storage Price': tireStoragePrice,
                    'Tire Storage Cost': tireStorageCost,
                    'Tire Storage Margin': `${tireStorageProfitPercentage}%`,

                    'Other Price': otherPrice,
                    'Other Cost': otherCost,
                    'Other Margin': `${otherProfitPercentage}%`,

                    'Fees Price': hazmatFeePrice,
                    'Fees Cost': hazmatFeeCost,
                    'Fees Margin': `${hazmatFeeProfitPercentage}%`,

                    'Order Discount': 0,
                    'Parts line discount': 0,
                    'Labor line discount': 0,
                    'Tire line discount': 0,
                    'Other line discount': 0,
                    'RO line discount': 0,
                  };

                  if (this.isSubletTrackingEnabled) {
                    obj['Sublet Price'] = subletPrice || 0;
                    obj['Sublet Cost'] = subletCost || 0;
                    obj['Sublet Margin'] = `${subletProfitPercentage || 0}%`;
                  }
                  this.finalData = [obj].concat(this.finalData);
                }
              },
              (error) => {
                this.helperService.showToaster('error', error);
              },
            )
            .finally(() => {
              this.processing = false;
            });
        },
        (error) => {
          this.helperService.showToaster('error', error);
        },
      )
      .finally(() => {
        this.processing = false;
      });
  }

  downloadGoogleReview(filter: any) {
    const tableConfig: any = {};
    const { isMultiLocationEnabled } = this.helperService.getCompany();

    if (filter.date.startDate && filter.date.endDate) {
      tableConfig.startDate = filter.date.startDate;
      tableConfig.endDate = filter.date.endDate;
    }

    if (filter.rating) {
      tableConfig.rating = filter.rating;
    }

    this.processing = true;
    this.httpService
      .getReportGoogleReviewList(tableConfig)
      .then(
        (data: any) => {
          this.finalData = this.formatService.formatReviewsReportExport(data.records);
        },
        (error) => {
          this.helperService.showToaster('error', error);
        },
      )
      .finally(() => {
        this.processing = false;
      });
  }

  downloadLaborReport(filter) {
    const tableConfig: any = {};
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    const { shopIds = { shopIds: [] } } = filter;
    if (isMultiLocationEnabled && (!shopIds || (shopIds && !shopIds.length))) return;

    if (filter.date.startDate && filter.date.endDate) {
      tableConfig.startDate = filter.date.startDate;
      tableConfig.endDate = filter.date.endDate;
    }

    if (shopIds.length > 0) {
      tableConfig.shopIds = shopIds;
    } else {
      tableConfig.shopIds = '';
    }

    tableConfig.sortField = 'itemName';
    tableConfig.sortOrder = 1;

    if (filter.rating) {
      tableConfig.rating = filter.rating;
    }
    tableConfig.searchQuery = this.dataService.itemName;

    if (this.isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoicedDate';
    }

    if (this.filter?.genericFilter && this.filter?.genericFilter?.selected?.length) {
      this.setFinalizeTypeFilter(this.filter.genericFilter.selected, tableConfig);
    }

    this.processing = true;
    this.httpService.getAllLaborsSoldReport(tableConfig).then(
      (data: any) => {
        this.finalData = this.formatService.formatLaborItemsSoldReportList(data[0].records);
        if (data[0].extras[0]) {
          const { totalAvgBillHours, totalAvgEstHours, totalAvgCost, totalAvgPrice, timeSold, totalEstimatedHours, totalBilledHours, totalCost, totalSalesValue, totalProfitability } =
            data[0].extras[0];
          let obj = {
            avgBillableHours: totalAvgBillHours.toFixed(2) || 0,
            avgEstimateHours: totalAvgEstHours.toFixed(2) || 0,
            avgCost: totalAvgCost.toFixed(2) || 0,
            avgPrice: totalAvgPrice.toFixed(2) || 0,
            timeSold: timeSold.toFixed(2) || 0,
            totalEstimateHours: totalEstimatedHours.toFixed(2) || 0,
            totalBillableHours: totalBilledHours.toFixed(2) || 0,
            totalCost: totalCost.toFixed(2) || 0,
            totalSales: totalSalesValue.toFixed(2) || 0,
            totalProfitability: totalProfitability.toFixed(2) || 0,
          };
          this.finalData = [obj].concat(this.finalData);
        }
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
        this.processing = false;
      },
    );
  }

  downloadLaborDrillDownReport(filter) {
    const tableConfig: any = {};
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    const { shopIds = { shopIds: [] } } = filter;
    if (isMultiLocationEnabled && (!shopIds || (shopIds && !shopIds.length))) return;

    if (filter.date.startDate && filter.date.endDate) {
      tableConfig.startDate = filter.date.startDate;
      tableConfig.endDate = filter.date.endDate;
      tableConfig.searchQuery = this.dataService.searchRoNumber;
      tableConfig.itemName = this.helperService.encodeURIComponent(this.dataService.itemName);
      tableConfig._id = this.activatedRoute.snapshot.params['id'];
    }

    if (shopIds.length > 0) {
      tableConfig.shopIds = shopIds;
    } else {
      tableConfig.shopIds = '';
    }

    if (filter.rating) {
      tableConfig.rating = filter.rating;
    }

    if (this.isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoiceDate';
    }

    this.processing = true;
    this.httpService.getLaborSoldReportById(tableConfig).then(
      (data: any) => {
        this.finalData = this.formatService.formatLaborDrillDown(data[0].records);
        this.processing = false;
        if (isMultiLocationEnabled) {
          this.mapMultilocationShop();
        }
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
        this.processing = false;
      },
    );
  }

  downloadInternalReview(filter) {
    const tableConfig: any = {};

    if (filter.date.startDate && filter.date.endDate) {
      tableConfig.startDate = filter.date.startDate;
      tableConfig.endDate = filter.date.endDate;
    }

    if (filter.rating) {
      tableConfig.rating = filter.rating;
    }

    if (filter.tech) {
      tableConfig.tech = filter.tech.id;
    }

    tableConfig.sort = 'invoiceDate';

    this.processing = true;
    this.httpService.getReportInternalReviewList(tableConfig).then(
      (data: any) => {
        this.finalData = this.formatService.formatInternalReviewsReportExport(data.records);
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  mapMultilocationShop() {
    this.shopsMap = this.dataService.shopsMap;
    for (let i = 0; i < this.finalData.length; i++) {
      this.finalData[i].shopId = this.shopsMap[this.finalData[i].shopId]?.shopName;
    }
  }

  downloadCannedDetailsServices(filter) {
    const tableConfig: any = {};
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    const { shopIds = { shopIds: [] } } = filter;
    if (isMultiLocationEnabled && (!shopIds || (shopIds && !shopIds.length))) return;

    if (filter.date.startDate && filter.date.endDate) {
      tableConfig.startDate = filter.date.startDate;
      tableConfig.endDate = filter.date.endDate;
    }

    tableConfig.title = this.activatedRoute.snapshot.params['id'];
    tableConfig.order = -1;
    tableConfig.limit = 15;
    tableConfig.skip = 0;

    if (this.isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
      tableConfig.sort = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoiceDate';
      tableConfig.sort = 'invoiceDate';
    }

    if (shopIds.length > 0) {
      tableConfig.shopIds = shopIds;
    } else {
      tableConfig.shopIds = '';
    }

    if (this.filter?.genericFilter && this.filter?.genericFilter?.selected?.length) {
      this.setFinalizeTypeFilter(this.filter.genericFilter.selected, tableConfig);
    }

    this.processing = true;
    this.httpService.getReportCannedServiceDetailList(tableConfig).then((data: any) => {
      this.finalData = this.formatService.formatCannedServiceDetailsReportExport(data.records);
      this.processing = false;
      if (isMultiLocationEnabled) {
        this.mapMultilocationShop();
      }
    }),
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
        this.processing = false;
      };
  }

  downloadCannedServices(filter) {
    const tableConfig: any = {};
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    const { shopIds = [], date = {}, category = {}, tech = {} } = filter;
    if (!date.startDate || !date.endDate) return;

    if (isMultiLocationEnabled && (!shopIds || (shopIds && !shopIds.length))) return;

    if (tech && tech.id) {
      tableConfig.tech = tech.id;
    } else {
      tableConfig.tech = null;
    }

    if (category && category.id) {
      tableConfig.category = category.id;
    } else {
      tableConfig.category = null;
    }

    if (date.startDate && date.endDate) {
      tableConfig.startDate = date.startDate;
      tableConfig.endDate = date.endDate;
      tableConfig.dateTitle = date.filterTitle;
    }

    if (this.isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoiceDate';
    }

    if (shopIds.length > 0) {
      tableConfig.shopIds = shopIds;
    } else {
      tableConfig.shopIds = [];
    }

    tableConfig.sort = '_id';
    if (this.filter?.genericFilter && this.filter?.genericFilter?.selected?.length) {
      this.setFinalizeTypeFilter(this.filter.genericFilter.selected, tableConfig);
    }

    this.processing = true;
    this.httpService.getReportCannedServiceList(tableConfig).then(
      (data: any) => {
        this.httpService.getReportCannedservice(tableConfig).then((cannedServiceStats: any) => {
          this.finalData = this.formatService.formatCannedServiceReportExport(data.records);

          if (cannedServiceStats.data) {
            let obj = {
              '# Sold': data && data.extras.totalSold,
              'Total hours worked': data.extras?.totalWorkedHours?.toFixed(2) || `${0}`,
              'Total hours billed': data.extras?.totalBilledHours?.toFixed(2) || `${0}`,

              'Parts margin': `${this.currencyPipe.transform(cannedServiceStats.data.totalPartValue || 0)}  (${cannedServiceStats.data.partsMargin}%)`,
              'Labor margin': `${this.currencyPipe.transform(cannedServiceStats.data.totalLaborValue || 0)} (${cannedServiceStats.data.laborMargin}%)`,
              'Tire margin': `${this.currencyPipe.transform(cannedServiceStats.data.totalTireValue || 0)} (${cannedServiceStats.data.tireMargin}%)`,
              'Sublet margin': `${this.currencyPipe.transform(cannedServiceStats.data?.totalSubletValue || 0)} (${cannedServiceStats.data?.subletMargin || 0}%)`,
              'Tire storage margin': `${this.currencyPipe.transform(cannedServiceStats.data.totalTireStorageValue || 0)} (${cannedServiceStats.data.tireStorageMargin}%)`,
              'Other margin': `${this.currencyPipe.transform(cannedServiceStats.data.totalOtherValue || 0)} (${cannedServiceStats.data.otherMargin}%)`,
              'Fee margin': `${this.currencyPipe.transform(cannedServiceStats.data.totalFeeValue || 0)} (${cannedServiceStats.data.feeMargin}%)`,

              'Avg price': `${this.currencyPipe.transform((data && data.extras?.totalAverage) || 0)}`,
              'Total cost': `${this.currencyPipe.transform((data && data.extras.totalCost) || 0)}`,
              'Total price': `${this.currencyPipe.transform((data && data.extras.totalPrice) || 0)}`,
              'Total profit': `${this.currencyPipe.transform((data && data.extras.totalProfit) || 0)}`,
              'Service discount': `${this.currencyPipe.transform(cannedServiceStats.data.serviceLevelDiscount || 0)}`,
              'Gross margin': `${cannedServiceStats.data.totalGrossValue || 0}%`,
            };
            this.finalData = [obj].concat(this.finalData);
          }
        });
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
        this.processing = false;
      },
    );
  }

  downloadCustomer(filter) {
    const tableConfig: any = {};

    if (filter.date.startDate && filter.date.endDate) {
      tableConfig.startDate = filter.date.startDate;
      tableConfig.endDate = filter.date.endDate;
    }

    if (filter.tags.selected.length > 0) {
      tableConfig.tags = filter.tags.selected.map((t) => t.name);
    } else {
      tableConfig.tags = [];
    }

    if (filter.lastSold && filter.lastSold.id) {
      tableConfig.lastSold = filter.lastSold.id;
    } else {
      tableConfig.lastSold = null;
    }

    if (filter.customerFleet) {
      if ((filter.customerFleet.regular && filter.customerFleet.fleet) || (!filter.customerFleet.regular && !filter.customerFleet.fleet)) {
        tableConfig.isFleetCustomer = null;
      } else {
        tableConfig.isFleetCustomer = filter.customerFleet.fleet;
      }
    }

    if (filter.companyName && filter.companyName.selected && filter.companyName.selected.length) {
      tableConfig.companyName = filter.companyName.selected.map(({ name }) => name);
    } else {
      tableConfig.companyName = [];
    }

    if (filter.shopIds && filter.shopIds.length > 0) {
      tableConfig.shopIds = filter.shopIds;
    }

    if (filter.customerType.newCustomers && filter.customerType.repeatCustomers) {
      tableConfig.customerType = 'all';
    } else if (filter.customerType.newCustomers) {
      tableConfig.customerType = 'new';
    } else if (filter.customerType.repeatCustomers) {
      tableConfig.customerType = 'old';
    } else {
      tableConfig.customerType = 'all';
    }

    if (this.isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoiceDate';
    }

    this.processing = true;
    this.httpService.getReportCustomerList(tableConfig).then(
      (data: any) => {
        if (data.records) {
          this.finalData = this.formatService.formatCustomerReportExport(data.records);
          if (data.extras) {
            let obj = {
              'Outstanding payments': data.extras.grandOutStandingPayments,
              'Total Payments': data.extras.grandPayments,
              'Total sales': data.extras.grandSales,
            };
            this.finalData = [obj].concat(this.finalData);
          }
        }

        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
        this.processing = false;
      },
    );
  }

  downloadOrders(filter) {
    const tableConfig: any = {};
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    const { shopIds = [], date = {}, orderStatus = {}, paymentStatus = {}, customerFleet = {}, workflow = {}, companyName = { selected: [] }, genericFilter = { selected: [] } } = filter;
    // Don't make call if date is missing
    if (!date.startDate || !date.endDate) return;
    if (isMultiLocationEnabled && (!shopIds || (shopIds && !shopIds.length))) return;

    if (orderStatus && orderStatus.estimate && orderStatus.invoice) {
      tableConfig.orderStatus = null;
    } else if (orderStatus && orderStatus.estimate) {
      tableConfig.orderStatus = 'estimate';
    } else if (orderStatus && orderStatus.invoice) {
      tableConfig.orderStatus = 'invoice';
    } else {
      tableConfig.orderStatus = null;
    }

    if (shopIds.length > 0) {
      tableConfig.shopIds = shopIds;
    } else {
      tableConfig.shopIds = [];
    }

    if (customerFleet) {
      if ((customerFleet.regular && customerFleet.fleet) || (!customerFleet.regular && !customerFleet.fleet)) {
        tableConfig.isFleetCustomer = null;
      } else {
        tableConfig.isFleetCustomer = customerFleet.fleet;
      }
    }

    tableConfig.archives = filter.archives;

    if (workflow && workflow.id) {
      tableConfig.workflow = workflow.id;
    } else {
      tableConfig.workflow = null;
    }

    if (companyName && companyName.selected && companyName.selected.length) {
      tableConfig.companyName = companyName.selected.map(({ name }) => name);
    } else {
      tableConfig.companyName = [];
    }

    if (paymentStatus && paymentStatus.id) {
      tableConfig.paymentStatus = paymentStatus.id;
    } else {
      tableConfig.paymentStatus = null;
    }

    if (date.startDate && date.endDate) {
      tableConfig.startDate = date.startDate;
      tableConfig.endDate = date.endDate;
    }

    tableConfig.search = this.dataService.itemName;

    if (genericFilter?.selected?.length) {
      this.formatService.formatFinalaizeRoType(genericFilter?.selected, tableConfig);
    }

    this.processing = false;
    this.httpService.getReportOrders(tableConfig).then(
      (response: any) => {
        this.httpService
          .getOrdersAggregate(tableConfig)
          .then(
            (data: any) => {
              if (data.records[0]) {
                const {
                  labor,
                  parts,
                  tires,
                  tireStorage,
                  other,
                  Fee,
                  itemDiscount,
                  serviceDiscount,
                  orderDiscount,
                  shopSupplies,
                  totalFee,
                  tax,
                  passThroughTax,
                  Totalorderamount,
                  card,
                  cash,
                  cheque,
                  creditPayment,
                  writeOff = 0,
                  thirdParty,
                } = data.records[0];

                this.finalData = this.formatService.formatOrderReportExport(response.records);
                if (isMultiLocationEnabled) {
                  this.shopsMap = this.dataService.shopsMap;
                  for (let i = 0; i < this.finalData.length; i++) {
                    this.finalData[i].shopId = this.shopsMap[this.finalData[i].shopId]?.shopName;
                  }
                }
                let obj = {
                  'Labor price': labor,
                  'Parts price': parts,
                  'Tire price': tires,
                  'Tire storage price': tireStorage,
                  Other: other,
                  Fee: Fee,
                  'RO Fee': totalFee,
                  Tax: this.calculationService.roundOff(tax),
                  'Passthrough Tax': passThroughTax,
                  'Item discount': itemDiscount,
                  'Service discount': serviceDiscount,
                  'Order discount': orderDiscount,
                  'Total paid': card + cash + cheque + creditPayment + thirdParty + writeOff,
                  'Total order amount': Totalorderamount,
                };
                this.finalData = [obj].concat(this.finalData);
              }
            },
            (error) => {
              this.helperService.showToaster('error', error);
            },
          )
          .finally(() => {
            this.processing = false;
          });
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  downloadOutstandingInvoice(filter) {
    const tableConfig: any = {};
    const { isMultiLocationEnabled } = this.helperService.getCompany();

    if (filter.date.endDate) {
      tableConfig.startDate = null;
      tableConfig.endDate = filter.date.endDate;
    }

    if (filter.tags.selected.length > 0) {
      tableConfig.tags = filter.tags.selected.map((t) => t.name);
    } else {
      tableConfig.tags = [];
    }

    if (filter.workflow && filter.workflow.id) {
      tableConfig.workflow = filter.workflow.id;
    } else {
      tableConfig.workflow = null;
    }

    if (filter.customerFleet) {
      if ((filter.customerFleet.regular && filter.customerFleet.fleet) || (!filter.customerFleet.regular && !filter.customerFleet.fleet)) {
        tableConfig.isFleetCustomer = null;
      } else {
        tableConfig.isFleetCustomer = filter.customerFleet.fleet;
      }
    }

    if (filter.companyName && filter.companyName.selected && filter.companyName.selected.length) {
      tableConfig.companyName = filter.companyName.selected.map(({ name }) => name);
    } else {
      tableConfig.companyName = [];
    }

    tableConfig.payment = filter.payment;
    tableConfig.archives = filter.archives;

    if (filter.aging && filter.aging.id) {
      tableConfig.aging = filter.aging.id;
    }

    tableConfig.search = this.dataService.itemName;

    if (isMultiLocationEnabled && filter.shopIds && filter.shopIds.length > 0) {
      tableConfig.shopIds = filter.shopIds;
    } else {
      tableConfig.shopIds = '';
    }

    if (this.isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoicedDate';
    }

    if (this.filter?.genericFilter && this.filter?.genericFilter?.selected?.length) {
      this.setFinalizeTypeFilter(this.filter.genericFilter.selected, tableConfig);
    }

    this.processing = true;
    this.httpService.getReportOutstandingInvoiceList(tableConfig).then(
      (res: any) => {
        this.httpService.getInvoiceOutstandingAggregate(tableConfig).then(
          (data: any) => {
            this.finalData = this.formatService.formatOutstandingInvoiceReportExport(res.records);
            if (this.finalData && this.finalData.length > 0 && data.records[0]) {
              const { Totalorderamount, cash, cheque, card, creditPayment, thirdParty } = data.records[0];
              let totalPaidAmount = card + cash + cheque + creditPayment + thirdParty;
              let totalRemainingAmount = Totalorderamount - totalPaidAmount;
              let obj = {
                'Order amount': Totalorderamount,
                'Payment amount': totalPaidAmount,
                'Remaining amount': totalRemainingAmount,
              };
              if (isMultiLocationEnabled) {
                this.shopsMap = this.dataService.shopsMap;
                for (let i = 0; i < this.finalData.length; i++) {
                  this.finalData[i].shopId = this.shopsMap[this.finalData[i].shopId]?.shopName;
                }
              }
              this.finalData = [obj].concat(this.finalData);
            }
            this.processing = false;
          },
          (error) => {
            this.processing = false;
            this.helperService.showToaster('error', error);
          },
        );
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  downloadAccountReceivable(filter) {
    const tableConfig: any = {};
    const { shopIds = [], date = {}, customerFleet = {}, tags = {} } = filter;
    if (shopIds && shopIds.length > 0) {
      tableConfig.shopIds = shopIds;
    } else {
      tableConfig.shopIds = [];
    }

    if (tags.selected.length > 0) {
      tableConfig.tags = tags.selected.map((t) => t.name);
    } else {
      tableConfig.tags = [];
    }

    if (this.isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoicedDate';
    }

    if (customerFleet) {
      if ((customerFleet.regular && customerFleet.fleet) || (!customerFleet.regular && !customerFleet.fleet)) {
        tableConfig.isFleetCustomer = null;
      } else {
        tableConfig.isFleetCustomer = customerFleet.fleet;

        if (date && customerFleet.fleet) {
          tableConfig.startDate = date.startDate;
          tableConfig.endDate = date.endDate;
        }
      }
    }
    tableConfig.search = this.dataService.itemName;
    tableConfig.order = this.dataService.sortOrder;
    tableConfig.endDate = this.dataService.customerAgingEndDate;
    tableConfig.genericFilter = true;
    tableConfig.skip = 0;
    tableConfig.sort = '';
    tableConfig.startDate = null;

    this.processing = true;
    this.httpService.getReportAccountsReceivableList(tableConfig).then(
      (data: any) => {
        this.finalData = this.formatService.formatAccountsReceivableReportList(data[0].records);
        if (data[0].extras[0]) {
          const { totalFirstMonth, totalSecondMonth, totalThirdMonth, totalMoreThanThreeMonths, total, totalInvoices, totalUnpaidStatements } = data[0].extras[0];
          let obj = {
            firstMonth: totalFirstMonth,
            secondMonth: totalSecondMonth,
            thirdMonth: totalThirdMonth,
            MoreThanThreeMonths: totalMoreThanThreeMonths,
            total: total,
            invoices: totalInvoices,
            unpaidStatements: totalUnpaidStatements,
          };
          this.finalData = [obj].concat(this.finalData);
        }
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  downloadArMovement(filter) {
    const tableConfig: any = {};
    const { date = {} } = filter;

    if (date) {
      tableConfig.startDate = date.startDate;
      tableConfig.endDate = date.endDate;
    }
    tableConfig.search = this.dataService.itemName;
    tableConfig.isExport = true;
    this.processing = true;
    this.httpService.getReportArMovement(tableConfig).then(
      (data: any) => {
        const arTotalBalance = data.data;
        this.finalData = data.records;
        this.runningBalance = arTotalBalance?.startingBalance || 0;
        if (this.finalData.length) {
          this.finalData.forEach((element) => {
            element.transactionDate = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(element.transactionDate).getTime()), datetimeFormat.mmmdyyhhmmaa);
            element.finalizeDate = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(element.finalizeDate).getTime()), datetimeFormat.mmmdyyyy);
            if (element.paymentDate) {
              element.paymentDate = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(element.paymentDate).getTime()), datetimeFormat.mmmdyyyy);
            }
            element.customer = element.customer?.displayName;
            if (element.transactionType === 'Invoice') {
              this.runningBalance += element.sendToAR;
            } else if (element.transactionType === 'Refund') {
              this.runningBalance += element.paidAgainstAR;
            } else {
              this.runningBalance -= element.paidAgainstAR;
            }
            element.balance = this.formatService.formatCurrency(this.runningBalance);
          });
        }
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  async downloadDailyPaymentReport() {
    this.paramFilters = this.helperService.deepCopy(this.dataService.tableConfigRegular);
    this.paramFilters.reportType = this.filterState.id;
    this.paramFilters.tableConfigFleet = JSON.stringify({ ...this.dataService.tableConfigFleet, bulkPayment: true });
    this.paramFilters.tableConfigRegular = JSON.stringify(this.dataService.tableConfigRegular);
    this.paramFilters.tableConfigReceivables = JSON.stringify(this.dataService.tableConfigReceivables);
    this.shopsMap = this.dataService.shopsMap;
    let csvData = [];
    const receivableList: any = await this.httpService.getReciveablesList(this.paramFilters);
    if (receivableList && receivableList.records) {
      csvData = this.formatReceiveableList(receivableList.records);
    }
    const regularList = await this.httpService.getRegularList(this.paramFilters.tableConfigRegular);
    if (regularList && regularList.records.length > 0) {
      csvData = [...csvData, ...this.formatRegularList(regularList.records)];
    }
    const fleetList = await this.httpService.getRegularList(this.paramFilters.tableConfigFleet);
    if (fleetList && fleetList.records.length > 0) {
      csvData = [...csvData, ...this.formatFleetList(fleetList.records)];
    }
    this.finalData = csvData;
    this.processing = false;
  }

  formatFleetList(records: any[]): any[] {
    return records.map((data: any) => {
      const { _id, statementName, paymentDate, customer, invoicesTotal, amount, shopId } = data;
      const fields = {
        location: this.shopsMap[shopId] && this.shopsMap[shopId].shopName,
        paymentDate: this.helperService.dateFormatMMMDDYY(paymentDate) ? this.helperService.dateFormatMMMDDYY(paymentDate) : '-',
        statementName: statementName ? statementName : '-',
        isFleetCustomer: customer.isFleetCustomer ? 'Fleet' : 'Regular',
        paymentMethod: this.formatService.getPaymentType(this.dataService.isOnlinePaymentEnable, data),
        customer: customer.displayName || customer.fullName ? customer.displayName || customer.fullName : '-',
        total: invoicesTotal ? invoicesTotal.toFixed(2) : '0.00',
        paid: amount ? amount.toFixed(2) : '0.00',
        _id: _id,
        activityType: 'Fleet Payments Received',
        type: 'daily',
      };

      return fields;
    });
  }

  formatRegularList(records: any[]): any[] {
    return records.map((data) => {
      const { paymentDate, roNumber, invoiceCode, customer, totalInvoiceAmount, amount, shopId, orderId } = data;
      const fields = {
        location: this.shopsMap[shopId] && this.shopsMap[shopId].shopName,
        paymentDate: this.helperService.dateFormatMMMDDYY(paymentDate) ? this.helperService.dateFormatMMMDDYY(paymentDate) : '-',
        invoiceCode: invoiceCode,
        roNumber: roNumber,
        isFleetCustomer: customer.isFleetCustomer ? 'Fleet' : 'Regular',
        paymentMethod: this.formatService.getPaymentType(this.dataService.isOnlinePaymentEnable, data).replace('creditPayment', 'credit payment'),
        customer: customer.displayName || customer.fullName ? customer.displayName || customer.fullName : '-',
        total: totalInvoiceAmount ? totalInvoiceAmount.toFixed(2) : '0.00',
        paid: amount ? amount.toFixed(2) : '0.00',
        orderId: orderId,
        activityType: 'Regular Payments Received',
        type: 'daily',
      };

      return fields;
    });
  }

  formatReceiveableList(records: any[]): any[] {
    return records.map(({ orders, shopId }) => {
      const fields = {
        location: this.shopsMap[shopId] && this.shopsMap[shopId].shopName,
        paymentDate: this.helperService.dateFormatMMMDDYY(orders.paymentDate) || '-',
        Invoice: orders.code ? orders.code : '-',
        customerType: orders && orders.customer && orders.customer.isFleetCustomer ? 'Fleet' : 'Regular',
        customer: orders && orders.customer ? orders.customer.displayName || orders.customer.fullName || '-' : '-',
        'outstanding-amount': orders.outstandingAmount ? orders.outstandingAmount.toFixed(2) : '0.00',
        total: orders.total ? orders.total.toFixed(2) : '0.00',
        orderId: orders.orderId,
        _id: orders.orderId ? orders.orderId : '-',
        activityType: 'Added to Receivables',
      };

      return fields;
    });
  }

  downloadAllPayments(filter) {
    let tableConfig: any = {};
    const { paymentType, qboStatus, date, tags, paymentSubTypeFilterOption, paymentGroup, companyName, shopIds } = filter;
    const { cash, card, cardManual, cardOnline, cheque, cardSwipe, creditPayment, thirdParty, writeOff } = paymentType;
    const { synced, notSynced, notPosted } = qboStatus;
    const { startDate, endDate } = date;
    const { isMultiLocationEnabled } = this.helperService.getCompany();

    if (tags.selected.length > 0) {
      tableConfig.tags = filter.tags.selected.map(({ name }) => name);
    } else {
      tableConfig.tags = [];
    }

    if (cash || cardManual || cardOnline || cheque || card || cardSwipe || creditPayment || thirdParty || writeOff) {
      tableConfig = { ...tableConfig, ...paymentType };
    }

    if ((!synced || !notSynced || !notPosted) && (synced || notSynced || notPosted)) {
      tableConfig = { ...tableConfig, ...qboStatus };
    }

    if (startDate && endDate) {
      tableConfig = { ...tableConfig, startDate, endDate };
    }

    if (filter.customerFleet) {
      if ((filter.customerFleet.regular && filter.customerFleet.fleet) || (!filter.customerFleet.regular && !filter.customerFleet.fleet)) {
        tableConfig.isFleetCustomer = null;
      } else {
        tableConfig.isFleetCustomer = filter.customerFleet.fleet;
      }
    }

    if (filter.companyName && filter.companyName.selected && filter.companyName.selected.length) {
      tableConfig.companyName = filter.companyName.selected.map(({ name }) => name);
    } else {
      tableConfig.companyName = [];
    }

    if (isMultiLocationEnabled && filter.shopIds && filter.shopIds.length > 0) {
      tableConfig.shopIds = filter.shopIds;
    } else {
      tableConfig.shopIds = '';
    }

    if (paymentSubTypeFilterOption.length > 0) {
      tableConfig.paymentSubTypes = [];
      paymentSubTypeFilterOption.map((rec) => {
        if (rec.selected) {
          tableConfig.paymentSubTypes.push(rec.name);
        }
      });
    }

    if (!(paymentGroup.refund && paymentGroup.payment) && !(!paymentGroup.refund && !paymentGroup.payment)) {
      if (paymentGroup.refund) {
        tableConfig = {
          ...tableConfig,
          paymentGroup: 'Refund',
        };
      } else {
        tableConfig = {
          ...tableConfig,
          paymentGroup: 'Payment',
        };
      }
    }
    tableConfig.sortField = this.dataService.sortField;
    tableConfig.sortOrder = this.dataService.sortOrder;

    this.processing = true;
    this.httpService.getPaymentReportList(tableConfig).then(
      (data: any) => {
        this.finalData = this.formatService.formatPaymentReportExport(data.records);
        if (isMultiLocationEnabled) {
          this.shopsMap = this.dataService.shopsMap;
          for (let i = 0; i < this.finalData.length; i++) {
            this.finalData[i].shopId = this.shopsMap[this.finalData[i].shopId]?.shopName;
          }
        }
        if (data.extras) {
          const { totalAmount, totalOrderAmt, totalRemainingAmt } = data.extras;
          let obj = {
            'Payment amount': totalAmount,
            'Order amount': totalOrderAmt,
            'Remaining amount': totalRemainingAmt,
          };
          this.finalData = [obj].concat(this.finalData);
        }
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  async downloadAllPaymentsStats(filter) {
    let tableConfig: any = {};
    const { paymentType, qboStatus, date, tags, paymentSubTypeFilterOption, paymentGroup, companyName, shopIds } = filter;
    const { cash, card, cardManual, cardOnline, cheque, cardSwipe, creditPayment, thirdParty } = paymentType;
    const { synced, notSynced, notPosted } = qboStatus;
    const { startDate, endDate } = date;
    const { isMultiLocationEnabled } = this.helperService.getCompany();

    if (tags.selected.length > 0) {
      tableConfig.tags = filter.tags.selected.map(({ name }) => name);
    } else {
      tableConfig.tags = [];
    }

    if (cash || cardManual || cardOnline || cheque || card || cardSwipe || creditPayment || thirdParty) {
      tableConfig = { ...tableConfig, ...paymentType };
    }

    if ((!synced || !notSynced || !notPosted) && (synced || notSynced || notPosted)) {
      tableConfig = { ...tableConfig, ...qboStatus };
    }

    if (startDate && endDate) {
      tableConfig = { ...tableConfig, startDate, endDate };
    }

    if (filter.customerFleet) {
      if ((filter.customerFleet.regular && filter.customerFleet.fleet) || (!filter.customerFleet.regular && !filter.customerFleet.fleet)) {
        tableConfig.isFleetCustomer = null;
      } else {
        tableConfig.isFleetCustomer = filter.customerFleet.fleet;
      }
    }

    if (filter.companyName && filter.companyName.selected && filter.companyName.selected.length) {
      tableConfig.companyName = filter.companyName.selected.map(({ name }) => name);
    } else {
      tableConfig.companyName = [];
    }

    if (isMultiLocationEnabled && filter.shopIds && filter.shopIds.length > 0) {
      tableConfig.shopIds = filter.shopIds;
    } else {
      tableConfig.shopIds = '';
    }

    if (paymentSubTypeFilterOption.length > 0) {
      tableConfig.paymentSubTypes = [];
      paymentSubTypeFilterOption.map((rec) => {
        if (rec.selected) {
          tableConfig.paymentSubTypes.push(rec.name);
        }
      });
    }

    if (!(paymentGroup.refund && paymentGroup.payment) && !(!paymentGroup.refund && !paymentGroup.payment)) {
      if (paymentGroup.refund) {
        tableConfig = {
          ...tableConfig,
          paymentGroup: 'Refund',
        };
      } else {
        tableConfig = {
          ...tableConfig,
          paymentGroup: 'Payment',
        };
      }
    }

    this.processing = true;
    this.httpService.getPaymentStatsReport(tableConfig).then(
      (res: any) => {
        if (res) {
          const { cash, cashPaymentCount, card, cardPaymentCount, cheque, chequePaymentCount } = res;
          this.paymentStats = [
            {
              pMethod: 'Cash',
              amount: cash || 0,
              count: cashPaymentCount || 0,
            },
            {
              pMethod: 'Cheque',
              amount: cheque || 0,
              count: chequePaymentCount || 0,
            },
            {
              pMethod: 'Card',
              amount: card || 0,
              count: cardPaymentCount || 0,
            },
          ];

          let downloadData = [];
          const columns = this.helperService.deepCopy(this.paymentStatsColumns);
          const data = this.helperService.deepCopy(this.paymentStats);

          if (['all-payments'].includes(this.id)) {
            // downloadData = this.finalData;
            data.forEach((e: any) => {
              const d = {};
              columns.forEach((n: any) => (d[n.name] = e[n.value] ? e[n.value] : 0));
              downloadData.push(d);
            });
          }
          this.exportService.JSONToCSVConvertor(downloadData, this.paymentStatsFilename, true, this.currentServerTime);
        }

        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  downloadTechnicianActivity(filter) {
    const tableConfig: any = {};
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    const { shopIds = [] } = filter;
    if (filter.date.startDate && filter.date.endDate) {
      tableConfig.startDate = filter.date.startDate;
      tableConfig.endDate = filter.date.endDate;
    }
    if (filter.tech && filter.tech.id) {
      tableConfig.tech = filter.tech.id;
    } else {
      tableConfig.tech = null;
    }
    if (filter.activity && filter.activity.services && filter.activity.inspections) {
      tableConfig.activity = null;
    } else if (filter.activity && filter.activity.services) {
      tableConfig.activity = 'service';
    } else if (filter.activity && filter.activity.inspections) {
      tableConfig.activity = 'inspection';
    } else {
      tableConfig.activity = null;
    }

    if (shopIds && shopIds.length > 0) {
      tableConfig.shopIds = shopIds;
    } else {
      tableConfig.shopIds = [];
    }

    this.processing = true;
    this.httpService.getReportTechTimeLogList(tableConfig).then(
      (data: any) => {
        this.finalData = this.formatService.formatTechLogsReportExport(data.records);
        if (isMultiLocationEnabled) {
          this.shopsMap = this.dataService.shopsMap;
          for (let i = 0; i < this.finalData.length; i++) {
            this.finalData[i].shopId = this.shopsMap[this.finalData[i].shopId]?.shopName;
          }
        }
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  downloadTechnicianSummary(filter) {
    const tableConfig: any = {};
    const { shopIds = [], date = {}, orderStatus = {}, roStatus = {}, paidStatus = {}, serviceCompleteDate = false } = filter;
    const { isMultiLocationEnabled } = this.helperService.getCompany();

    if (date.startDate && date.endDate) {
      tableConfig.startDate = date.startDate;
      tableConfig.endDate = date.endDate;
      tableConfig.dateTitle = date.filterTitle || 'All Time';
    }

    if (isMultiLocationEnabled && shopIds && shopIds.length > 0) {
      tableConfig.shopIds = filter.shopIds;
    } else {
      tableConfig.shopIds = [];
    }

    tableConfig.serviceCompleteDate = this.dataService.serviceCompleteDate;

    tableConfig.orderType = {
      estimate: !!roStatus?.estimate,
      invoice: !!roStatus?.invoice,
      finalized: !!roStatus?.finalized,
    };

    if (orderStatus && orderStatus.estimate && orderStatus.invoice) {
      tableConfig.orderStatus = null;
    } else if (orderStatus && orderStatus.estimate) {
      tableConfig.orderStatus = 'estimate';
    } else if (orderStatus && orderStatus.invoice) {
      tableConfig.orderStatus = 'invoice';
    } else {
      tableConfig.orderStatus = null;
    }

    if (paidStatus) {
      const { paid = false, partiallyPaid = false, unPaid = false } = paidStatus;
      if (Array.from(new Set([paid, partiallyPaid, unPaid])).length > 1) {
        tableConfig.orderStatus = { paid, partiallyPaid, unPaid };
      } else {
        tableConfig.orderStatus;
      }
    }

    tableConfig.sort = 'name';
    tableConfig.order = -1;
    tableConfig.techSummaryReportEmptyState = true;
    this.processing = true;
    this.httpService.getReportTechSummary(tableConfig).then(
      (data: any) => {
        if (data.records) {
          const filteredEfficiency = data.chartData?.efficiency?.filter((eff) => data.records.some((record) => record._id === eff._id)) || [];

          this.finalData = this.formatService.formatTechSummaryReportList(data.records, this.dataService.isSplitTechActuallBillableHrs, filteredEfficiency);
          // === Add total row at the top ===
          // const actualWorked = data.extras?.actualWorkedHours || {};
          // const billable = data.extras?.billableHours || {};
          // const estimated = data.extras?.estimatedHours || {};

          // const totalsRow = {
          //   name: 'Totals',
          //   singleTechServices: '',
          //   multiTechServices: '',

          //   // === Billable Hours ===
          //   billableTotalHours: billable.totalHours?.toFixed(2) || '0.00',
          //   billableTotalCost: billable.totalCost ? '$' + billable.totalCost.toFixed(2) : '$0.00',
          //   billableApprovedHours: billable.approvedHours?.toFixed(2) || '0.00',
          //   billableApprovedCost: billable.approvedCost ? '$' + billable.approvedCost.toFixed(2) : '$0.00',

          //   // === Estimated Hours ===
          //   estimatedTotalHours: estimated.totalHours?.toFixed(2) || '0.00',
          //   estimatedTotalCost: estimated.totalCost ? '$' + estimated.totalCost.toFixed(2) : '$0.00',
          //   estimatedApprovedHours: estimated.approvedHours?.toFixed(2) || '0.00',
          //   estimatedApprovedCost: estimated.approvedCost ? '$' + estimated.approvedCost.toFixed(2) : '$0.00',

          //   // === Actual Worked Hours ===
          //   actualTotalHours: actualWorked.totalHours?.toFixed(2) || '0.00',
          //   actualTotalCost: actualWorked.totalCost ? '$' + actualWorked.totalCost.toFixed(2) : '$0.00',
          //   actualApprovedHours: actualWorked.approvedHours?.toFixed(2) || '0.00',
          //   actualApprovedCost: actualWorked.approvedCost ? '$' + actualWorked.approvedCost.toFixed(2) : '$0.00',
          // };

          // this.finalData = [totalsRow, ...this.finalData];
          this.finalData = [...this.finalData];
        }
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  downloadTechnicianSummaryAllServices(filter) {
    const tableConfig: any = {};
    const { shopIds = [], date = {}, dateType, orderStatus = {}, paidStatus = {} } = filter;
    const { isMultiLocationEnabled } = this.helperService.getCompany();

    if (date.startDate && date.endDate) {
      tableConfig.startDate = date.startDate;
      tableConfig.endDate = date.endDate;
    }

    if (isMultiLocationEnabled && shopIds && shopIds.length > 0) {
      tableConfig.shopIds = filter.shopIds;
    } else {
      tableConfig.shopIds = '';
    }

    if (orderStatus && orderStatus.estimate && orderStatus.invoice) {
      tableConfig.orderStatus = null;
    } else if (orderStatus && orderStatus.estimate) {
      tableConfig.orderStatus = 'estimate';
    } else if (orderStatus && orderStatus.invoice) {
      tableConfig.orderStatus = 'invoice';
    } else {
      tableConfig.orderStatus = null;
    }

    if (paidStatus) {
      const { paid = false, partiallyPaid = false, unPaid = false } = paidStatus;
      if (Array.from(new Set([paid, partiallyPaid, unPaid])).length > 1) {
        tableConfig.orderStatus = { paid, partiallyPaid, unPaid };
      } else {
        tableConfig.orderStatus;
      }
    }

    if (dateType) tableConfig.dateType = dateType;
    tableConfig.sort = 'name';
    tableConfig.order = -1;
    this.processing = true;
    this.httpService.getReportTechSummaryByAllService(tableConfig).then(
      (data: any) => {
        if (data.records) {
          // this.finalData = data.records;
          this.finalData = this.formatService.formatTechSummaryAllServicesReportExport(data.records);
        }
        if (data.extras) {
          const { billableHours, estimatedHours } = data.extras;
          let obj = {
            // === Estimated Hours ===
            estimatedTotalHours: `${this.calculationService.roundOff(estimatedHours.totalHours)}`,
            estimatedTotalCost: `$${this.calculationService.roundOff(estimatedHours.totalCost)}`,
            estimatedApprovedHours: `${this.calculationService.roundOff(estimatedHours.approvedHours)}`,
            estimatedApprovedCost: `$${this.calculationService.roundOff(estimatedHours.approvedCost)}`,

            // === Billable Hours ===
            billableTotalHours: `${this.calculationService.roundOff(billableHours.totalHours)}`,
            billableTotalCost: `$${this.calculationService.roundOff(billableHours.totalCost)}`,
            billableApprovedHours: `${this.calculationService.roundOff(billableHours.approvedHours)}`,
            billableApprovedCost: `$${this.calculationService.roundOff(billableHours.approvedCost)}`,
          };
          this.finalData = [obj].concat(this.finalData);
        }
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  downloadAccPayableSupplier(filter) {
    const tableConfig: any = {};
    const { supplierType = {} } = filter;

    if (this.isSubletTrackingEnabled && this.dataService.isFilterOnSublet) {
      tableConfig.type = ['sublet'];
    } else {
      if ((!supplierType.internal && !supplierType.online) || (supplierType.internal && supplierType.online)) {
        tableConfig.type = ['online', 'internal'];
      } else if (supplierType.internal || supplierType.online) {
        tableConfig.type = supplierType.online ? ['online'] : ['internal'];
      }
    }

    tableConfig.search = this.dataService.itemName;
    this.processing = true;
    this.httpService.getReportAPlistSupplier(tableConfig).then(
      (res: any) => {
        if (res && res.length) {
          this.finalData = this.formatService.formatAPSupplierReportList(res && res.length ? res[0].records : []);
        }
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  downloadAccPayableSupplierDetails(filter) {
    const tableConfig: any = {};

    const { shopIds = [], date = {}, paidStatus = {}, genericFilter = { selected: [] } } = filter;

    tableConfig._id = this.activatedRoute.snapshot.params['id'];

    if (this.isSubletTrackingEnabled && this.query?.isFilterOnSublet === '1') {
      tableConfig.type = 'sublet';
    }

    if (paidStatus) {
      const { paid = false, partiallyPaid = false, unPaid = false } = paidStatus;

      if (Array.from(new Set([paid, partiallyPaid, unPaid])).length > 1) {
        tableConfig.paidStatus = { paid, partiallyPaid, unPaid };
      } else {
        delete tableConfig.paidStatus;
      }
    }
    //if (activityType.selected.length > 0) {
    if (genericFilter && genericFilter?.selected.length > 0) {
      //tableConfig.activityType = activityType.selected.map(({ id }) => id);
      tableConfig.activityType = genericFilter.selected.map(({ value }) => value);
    } else {
      tableConfig.activityType = [];
    }
    if (date.startDate && date.endDate) {
      tableConfig.startDate = date.startDate;
      tableConfig.endDate = date.endDate;
    }

    this.processing = true;
    this.httpService.getReportAPlistSupplierDrillDown({ ...tableConfig, search: this.dataService.searchQuery }, tableConfig).then(
      (res: any) => {
        if (res && res.length) {
          const openingBal = res[0]?.extras[0]?.openingBalance || 0;
          if (this.isSubletTrackingEnabled && this.query?.isFilterOnSublet === '1') {
            this.finalData = this.formatService.formatAPSupplierReportDetailListSubletVersion(res[0].records, openingBal);
          } else {
            this.finalData = this.formatService.formatAPSupplierReportDetailList(res[0].records, openingBal);
          }
          this.finalData.unshift({
            code: 'Opening Balance',
            runningBalance: res[0]?.extras[0]?.openingBalance,
          });
          this.finalData.push({
            code: 'Closing Balance',
            runningBalance: res[0]?.extras[0]?.closingBalance || 0,
          });
        }
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  async downloadAPMovementData(filter: any) {
    const dateFilter = this.dataService.itemMovementReturnDateFilter;
    const { shopIds = { shopIds: [] } } = filter;

    const { isMultiLocationEnabled } = this.helperService.getCompany();
    if (isMultiLocationEnabled && (!shopIds || (shopIds && !shopIds.length))) return;
    this.searchQuery = this.dataService.itemName;
    const tableConfig: any = {
      startDate: filter.date.startDate,
      endDate: filter.date.endDate,
      search: this.searchQuery,
      itemTypeInventoryNonInventory: filter.itemTypeInventoryNonInventory.selected.map(({ value }) => value),
      order: -1,
      page: 0,
      skip: 0,
      sort: 'transactionDate',
      paidStatus: '',
      isFirstPage: true,

      shopIds,
    };
    // {"skip":0,"isFirstPage":true,"page":0,"limit":8,"sort":"","order":-1,"search":"","startDate":"2024-04-09","endDate":"2024-04-09","itemTypeInventoryNonInventory":[],"paidStatus":"","dateFilter":"itemReturnDate"};
    this.processing = true;
    try {
      const combineAllData = [];
      const [apPurchases, apSales, apReturns, apAdjustments, apStockTransfer]: any = await Promise.all([
        this.httpService.getReportAPMovementPurchases({ ...tableConfig, paidStatus: this.dataService.paidStatus, isExportedToAP: this.dataService.isExportedToAP }),
        this.httpService.getReportAPMovementSales({ ...tableConfig }),
        this.httpService.getReportAPMovementReturns({ ...tableConfig, dateFilter, isExportedToReturn: this.dataService.isExportedToReturn }),
        this.httpService.getReportAPMovementAdjustments({ ...tableConfig }),
        this.httpService.getReportAPMovementStockTransfer({ ...tableConfig }),
      ]);
      if (apPurchases) {
        apPurchases[0].records.forEach((item) => (item.activity = 'Purchase'));
        combineAllData.push(...apPurchases[0].records);
      }
      if (apSales) {
        apSales[0].records.forEach((item) => (item.activity = 'Sale'));
        combineAllData.push(...apSales[0].records);
      }
      if (apReturns) {
        apReturns[0].records.forEach((item) => (item.activity = 'Return'));
        combineAllData.push(...apReturns[0].records);
      }
      if (apAdjustments) {
        apAdjustments[0].records.forEach((item) => (item.activity = 'Adjustment'));
        combineAllData.push(...apAdjustments[0].records);
      }

      if (isMultiLocationEnabled && this.dataService.isStockTransferEnabled && apStockTransfer) {
        apStockTransfer[0].records.forEach((item) => (item.activity = 'Stock Transfer'));
        combineAllData.push(...apStockTransfer[0].records);
      }
      this.finalData = this.formatService.formateAPMovement(combineAllData);
      // const totalCommissionEarned: any = (totalCommission && totalCommission.commissionEarned) || 0;
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.processing = false;
    }
  }

  downloadTechnicianSummaryAllServicesDetails(filter) {
    const tableConfig: any = {};
    const { shopIds = [], date = {}, tech = {} } = filter;
    const { isMultiLocationEnabled } = this.helperService.getCompany();

    if (date.startDate && date.endDate) {
      tableConfig.startDate = date.startDate;
      tableConfig.endDate = date.endDate;
    }

    if (isMultiLocationEnabled && shopIds && shopIds.length > 0) {
      tableConfig.shopIds = filter.shopIds;
    } else {
      tableConfig.shopIds = '';
    }

    if (filter && filter.title) {
      tableConfig.techs = filter.title;
    } else {
      tableConfig.techs = null;
    }
    if (tech && tech?.id) {
      tableConfig.techs = tech.id;
    } else if ((tableConfig.techs = 'unassigned')) {
      tableConfig.techs = 'unassigned';
    } else {
      tableConfig.techs = '';
    }

    if (this.isRevenueRecognitionSettleEnabled) {
      tableConfig.dateType = 'finalizeDate';
    } else {
      tableConfig.dateType = 'invoiceDate';
    }

    this.processing = true;
    this.httpService.getTechnicianByAllServiceDrillDown(tableConfig, {}).then(
      (data: any) => {
        if (data.records) {
          this.finalData = this.formatService.formatTechSummaryAllServicesDrillDownReportExport(data.records);
        }
        if (data.extras) {
          const { actualWorkedHours, billableHours, estimatedHours } = data.extras;
          let obj = {
            estimatedTotalHours: `${this.calculationService.roundOff(estimatedHours.totalHours || 0)} ($${estimatedHours.totalCost})`,
            estimatedApprovedHours: `${this.calculationService.roundOff(estimatedHours.approvedHours || 0)} ($${estimatedHours.approvedCost})`,

            billableTotalHours: `${billableHours.totalHours} ($${billableHours.totalCost})`,
            billableApprovedHours: `${billableHours.approvedHours} ($${billableHours.approvedCost})`,
          };
          this.finalData = [obj].concat(this.finalData);
          if (isMultiLocationEnabled) {
            this.mapMultilocationShop();
          }
        }
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  async downloadAttendanceLogDetails(filter) {
    try {
      this.processing = true;
      const {
        title: techId,
        date: { startDate, endDate },
      } = filter;

      const data: any = await this.httpService.getAttendanceLogDetailsList({
        techId,
        startDate,
        endDate,
      });

      this.finalData = this.formatService.formatAttendanceLogDetailsExport(data.records || []);
    } catch (error) {
      this.helperService.showToaster('error', error);
    } finally {
      this.processing = false;
    }
  }

  async downloadInventoryLogs(filters) {
    try {
      this.processing = true;
      const { isMultiLocationEnabled } = this.helperService.getCompany();
      const { shopIds = [], date = {}, items = { selected: [] }, qtyType = {}, location = { selected: [] } } = filters;
      const { startDate, endDate } = date;
      const { selected: selectedItems = [] } = items;
      const { selected: selectedLocations = [] } = location;

      // reset filter state first
      const filterState: any = {
        startDate,
        endDate,
        items: [],
        qtyType: [],
        locations: [],
        searchQuery: '',
      };

      // on items select
      selectedItems.forEach((item) => {
        if (item.itemId) {
          filterState.items.push(item.itemId);
        }
      });

      selectedLocations.forEach((loc) => {
        if (loc._id) {
          filterState.locations.push(loc._id);
        }
      });

      Object.keys(qtyType).forEach((key) => {
        if (qtyType[key]) {
          filterState.qtyType.push(key);
        }
      });

      filterState.searchQuery = this.dataService.itemName;

      if (this.dataService.searchRoNumber && this.dataService.itemName) {
        delete filterState.startDate;
        delete filterState.endDate;
        filterState.rows = 10;
        filterState.first = 0;
      }

      if (isMultiLocationEnabled && shopIds && shopIds.length > 0) {
        filterState.shopIds = shopIds;
      } else {
        filterState.shopIds = '';
      }

      const data: any = await this.httpService.getInventoryLogs(filterState);

      if (data.records && data.records.length >= 0) {
        data.records.forEach(
          (record: any) => (record.createdAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(record.createdAt).getTime()), datetimeFormat.mmmdyyhhmmaa)),
        );
        this.finalData = data.records;
      } else {
        this.finalData = [];
      }
    } catch (error) {
      this.helperService.showToaster('error', error);
    } finally {
      this.processing = false;
    }
  }

  async downloadInventoryLevelReport(filters) {
    try {
      this.processing = true;
      const { isMultiLocationEnabled } = this.helperService.getCompany();
      const { shopIds = [], date = {}, items = { selected: [] }, qtyType = {}, location = { selected: [] } } = filters;
      const { startDate, endDate } = date;
      const { selected: selectedItems = [] } = items;
      const { selected: selectedLocations = [] } = location;

      // reset filter state first
      const filterState: any = {
        startDate,
        endDate,
        items: [],
        qtyType: [],
        locations: [],
        sortField: this.dataService.sortField,
        sortOrder: this.dataService.sortOrder,
        searchQuery: '',
      };

      // on items select
      selectedItems.forEach((item) => {
        if (item.itemId) {
          filterState.items.push(item.itemId);
        }
      });

      selectedLocations.forEach((loc) => {
        if (loc._id) {
          filterState.locations.push(loc._id);
        }
      });

      Object.keys(qtyType).forEach((key) => {
        if (qtyType[key]) {
          filterState.qtyType.push(key);
        }
      });
      filterState.searchQuery = this.dataService.itemName;
      if (this.dataService.searchRoNumber && this.dataService.itemName) {
        delete filterState.startDate;
        delete filterState.endDate;
        filterState.rows = 10;
        filterState.first = 0;
      }

      if (isMultiLocationEnabled && shopIds && shopIds.length > 0) {
        filterState.shopIds = shopIds;
      } else {
        filterState.shopIds = '';
      }

      const data: any = await this.httpService.getInventoryLevelReport(filterState);

      this.finalData = this.formatService.inventortyListFormat(data.records) || [];
    } catch (error) {
      this.helperService.showToaster('error', error);
    } finally {
      this.processing = false;
    }
  }

  async downloadTaxDrilldown(filters: any) {
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    const { shopIds = [] } = filters;
    if (this.query && this.query.value) {
      filters.type = this.query.value.type;
    }

    if (this.isRevenueRecognitionSettleEnabled) {
      filters.dateType = 'finalizeDate';
      filters.sort = 'finalizeDate';
    } else {
      filters.dateType = 'invoiceDate';
    }

    if (this.filter?.genericFilter && this.filter?.genericFilter?.selected?.length) {
      this.setFinalizeTypeFilter(this.filter.genericFilter.selected, filters);
    }

    if (isMultiLocationEnabled && shopIds && shopIds.length > 0) {
      filters.shopIds = shopIds;
    } else {
      filters.shopIds = '';
    }

    try {
      if (this.processing) return;
      this.processing = true;

      const taxMap = {
        '': 'Unassigned tax rate',
      };
      const [taxes, data]: any = await Promise.all([this.httpService.getTaxesData(), this.httpService.getTaxRateReportList(filters)]);

      [...(taxes.taxCodes || []), ...(taxes.taxRates || [])].forEach(({ _id, name, salesTaxRate }) => {
        taxMap[_id] = { name, salesTaxRate };
      });

      const taxRates = this.formatService.formatTaxRatesForReport(data.records) || [];

      this.allColumns.taxRateDrilldown.forEach((col: any, index: number) => {
        if (['taxRateAmount', 'taxRatePercentage'].includes(col.value) && this.filterState.taxRateId) {
          if (this.filterState.taxRateId === 'unassigned') {
            this.allColumns.taxRateDrilldown[index].name = `${col.name}`;
          } else {
            this.allColumns.taxRateDrilldown[index].name = `${col.name}`;
          }
        }
      });

      this.finalData = taxRates.map((taxRate: any) => {
        const taxRateForExport = {};

        this.allColumns.taxRateDrilldown.forEach((col: any) => {
          const { name, value, isChecked } = col;
          if (isChecked) {
            if (['taxRateId', 'taxCodeId'].includes(value)) {
              taxRateForExport[name] = (taxMap[taxRate[value]] && taxMap[taxRate[value]].name) || '';
            } else if (['taxRateAmount', 'taxRatePercentage', 'taxAmount', 'taxPercentage']) {
              taxRateForExport[name] = taxRate[value] || 0;
            } else {
              taxRateForExport[name] = taxRate[value] || '';
            }
          }
        });

        return taxRateForExport;
      });
      if (isMultiLocationEnabled) {
        this.mapMultilocationShop();
      }
    } catch (error) {
      this.helperService.showToaster('error', error);
    } finally {
      this.processing = false;
    }
  }

  async donwloadTaxReport(filters: any) {
    try {
      if (this.processing) return;
      this.processing = true;

      const taxMap = {};
      const [taxes, data]: any = await Promise.all([this.httpService.getTaxesData(), this.httpService.getTaxReportList(filters)]);

      [...(taxes.taxCodes || []), ...(taxes.taxRates || [])].forEach(({ _id, name, salesTaxRate }) => {
        taxMap[_id] = { name, salesTaxRate };
      });

      const taxRates = this.formatService.formatTaxesForReport(data) || [];
      //  to show this for Total value
      const total = {
        'Tax Code': 'Total',
        'Tax code %': '',
        'Tax rate': '',
        'Gross Amount': this.calculationService.roundOff(taxRates[0]?.grossAmount || 0),
        'Non-taxable amount': this.calculationService.roundOff(taxRates[0]?.nonTaxableAmount || 0),
        'Taxable Amount': this.calculationService.roundOff(taxRates[0]?.taxableAmount || 0),
        'Tax amount': this.calculationService.roundOff(taxRates[0]?.taxedAmount || 0),
      };

      if (this.dataService.isCountTaxExemptROAsNonTaxedEnable) {
        delete total['Non-taxable amount'];
        delete total['Taxable Amount'];
        total['Non-taxed amount'] = this.calculationService.roundOff(taxRates[0]?.nonTaxableAmount || 0);
        total['Taxed amount'] = this.calculationService.roundOff(taxRates[0]?.taxableAmount || 0);
      }

      taxRates.splice(0, 1);

      this.finalData = taxRates
        .map((taxRate: any) => {
          const taxCode = {};
          //  don't need to map subline items in export
          if (taxRate.isSubLineItem) {
            return null;
          }
          this.allColumns.taxReport.forEach(({ name, value, isChecked }) => {
            if (isChecked) {
              if (['id', 'taxCodeId'].includes(value)) {
                taxCode[name] = (taxMap[taxRate[value]] && taxMap[taxRate[value]].name) || '';

                if (value === 'id' && !taxRate[value]) {
                  // taxCode[name] = '';
                  taxCode['Tax Code'] = 'Customer tax Exempt';
                }
                if (taxRate.taxRateName === 'Passthrough Tax') taxCode['Tax Code'] = 'Passthrough Tax';
              } else if (['percentage', 'taxRatePercentage'].includes(value)) {
                if (value === 'percentage') {
                  taxCode[name] = (taxMap[taxRate.taxCodeId] && taxMap[taxRate.taxCodeId].salesTaxRate) || 0;
                } else if (value === 'taxRatePercentage' && taxRate.type === 'taxRate') {
                  taxCode[name] = (taxMap[taxRate.id] && taxMap[taxRate.id].salesTaxRate) || '';
                }

                if (!taxRate.id) {
                  taxCode[name] = (taxMap[taxRate.taxCodeId] && taxMap[taxRate.taxCodeId].salesTaxRate) || 0;
                }
              } else if (['taxableAmount', 'nonTaxableAmount'].includes(value) && taxRate.type === 'taxRate' && taxRate.isSubLineItem) {
                taxCode[name] = taxRate[value] || 0;
              } else if (['taxedAmount'].includes(value)) {
                taxCode[name] = taxRate[value] || 0;
              } else {
                if (['grossAmount'].includes(value) && !taxRate.isSubLineItem) {
                  taxCode[name] = taxRate['totalGrossAmount'] || '';
                } else if (['grossAmount'].includes(value) && taxRate.isSubLineItem) {
                  taxCode[name] = '';
                } else {
                  taxCode[name] = taxRate[value] || '';
                }
              }

              if (taxRate.type === 'taxCode' && ['taxRatePercentage'].includes(value)) {
                taxCode[name] = '';
              }
            }
          });
          return taxCode;
        })
        .filter((element) => element !== null);
      this.finalData.unshift(total);
    } catch (error) {
      this.helperService.showToaster('error', error);
    } finally {
      this.processing = false;
    }
  }

  downloadTechnicianDrillDown(filter) {
    const query: any = {
      csv: true,
    };
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    if (isMultiLocationEnabled && filter.shopIds && filter.shopIds.length > 0) {
      query.shopIds = filter.shopIds;
    } else {
      query.shopIds = '';
    }

    if (filter.date.startDate && filter.date.endDate) {
      query.startDate = filter.date.startDate;
      query.endDate = filter.date.endDate;

      if (filter.tech && filter.tech.id) {
        query.techs = filter.tech.id;
      }
    }
    query.reportFormat = 'export';
    query.serviceCompleteDate = this.dataService.serviceCompleteDate;
    
    this.processing = true;

    this.httpService.getTechnicianDrillDown(query, this.columns).then(
      (data: any) => {
        this.finalData = data;
        this.downloadCSV();
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  downloadTechnicianAllSummaryDrillDown(filter) {
    const query: any = {
      csv: true,
    };

    if (filter.date.startDate && filter.date.endDate) {
      query.startDate = filter.date.startDate;
      query.endDate = filter.date.endDate;

      if (filter.tech && filter.tech.id) {
        query.techs = filter.tech.id;
      }
    }
    query.reportFormat = 'export';
    this.processing = true;
    this.httpService.getTechnicianByAllServiceDrillDown(query, this.columns).then(
      (data: any) => {
        this.finalData = data;
        this.downloadCSV();
        this.processing = false;
      },
      (error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      },
    );
  }

  downloadWarrantiesReport(filter) {
    let tableConfig: any = this.dataService.tableConfig;
    const { limit, skip, page, ...rest } = tableConfig;
    tableConfig = rest;
    this.processing = true;

    // Fetch warranty report data from the service
    this.httpService
      .getWarrantyReportList(tableConfig)
      .then((warrantyData: any) => {
        const response = warrantyData[0]?.records;
        if (response?.length) {
          this.finalData = response.map((data) => ({
            ...data,
            oFinalizationDate:
              data.oFinalizationDate && data.oFinalizationDate !== '-'
                ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(data.oFinalizationDate).getTime()), datetimeFormat.mmmdyyyy)
                : '-',
            invoiceDate:
              data.invoiceDate && data.invoiceDate !== '-' ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(data.invoiceDate).getTime()), datetimeFormat.yyymmdd) : '',
          }));
        }
        this.processing = false;
      })
      .catch((error) => {
        this.processing = false;
        this.helperService.showToaster('error', error);
      });
  }

  downloadCSV() {
    const uri = 'data:text/csv;charset=utf-8,' + escape(this.finalData);
    const link: any = document.createElement('a');
    link.href = uri;
    link.style = 'visibility:hidden';
    link.download = `${this.fileName}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  hasCheckedColumns(): boolean {
    if (!this.columns || this.columns.length === 0) return false;

    if (this.id === 'profitability') {
      return this.finalData.length > 1;
    } else {
      return this.columns.some((col) => col.isChecked);
    }
  }
}
